export const SET_LOADING = 'set_loading';

export const SET_SIDE_MENU = "side_menu";
export const FETCH_DP_WISE_SIDEMENU = "fetch_dp_wise_sidemenu";
export const FETCH_DP_WISE_SIDEMENU_LOADING = "fetch_dp_wise_sidemenu_loading";
export const SET_USER_OU = "user_ou";
export const SET_SELECTED_OU = "selected_ou";
export const SET_SELECTED_VESSELS = "set_selected_vessels";
export const SET_FILTERED_VESSELS = "set_filtered_vessels";
export const SET_HUB_FILTERED_VESSELS = "set_hub_filtered_vessels";
export const SET_SELECTED_VESSEL = "set_selected_vessel"
export const SET_SELECTED_AGENT = "set_selected_agent"
export const SET_PERMISSION_OBSERVER = "set_permission_observer";
export const SET_IS_USER_OU_HAS_SUB_OUS = "is_user_ou_has_sub_ous";
export const SET_PARENT_AND_SUBDP_LIST = 'set_parent_and_subdp_list';
export const SET_READONLY_USER = 'set_readonly_user';
// Before login
export const LOGIN_USER = "login_user";
export const LOGOUT_USER = "logout_user";
export const VERIFY_USER = "verify_user";
export const RESET_PASSWORD = "reset_password";
export const RECOVERY_PASSWORD_USER = "recovery_password_user";
export const CHANGE_PASSWORD = "change_password";
export const OTP_GENERATION_STATUS="otp_generation_status";
export const IS_PRIVATE_ENABLED="is_private_enabled";
export const IS_PRIVATE_LOADING="is_private_loading";

// Summary
export const FETCH_VESSEL = "fetch_vessel";

//Account Management
export const SET_FETCH_USERS_LOADING = "set_fetch_users_loading";
export const FETCH_USERS = "fetch_users";
export const INVITE_USER = "invite_user";
export const INVITE_USER_LOADING = "invite_user_loading";
export const RESEND_INVITE = 'resend_invite';
export const RESEND_INVITE_LOADING = "resend_invite_loading";
export const GET_ORGANISATIONS = 'get_organisations';
export const GET_ORGANISATIONS_UNITS = "get_organisations_units";
export const SET_FETCH_OU_RESOURCES_LOADING = "set_fetch_ou_resources_loading";
export const FETCH_OU_RESOURCES = 'fetch_ou_resources';
export const OU_POLICY = "ou_policy";
export const USER_DETACH_LOADING = "user_detach_loading";
export const USER_DETACH = "user_detach";
export const USER_DELETE_LOADING = "user_delete_loading";
export const USER_DELETE = "user_delete";
export const DISPLAY_APPLICABLE_USER_POLICIES = "display_applicable_user_policies";
export const POLICIES_DETAILS = "policies_details";
export const UPDATE_USER_LOADING = "update_user_loading";
export const UPDATE_USER = "update_user";
export const UPDATE_USER_ORGANIZATION_LOADING = "update_user_organization_loading";
export const UPDATE_USER_ORGANIZATION = "update_user_organization";
export const ENABLE_USER_ACCOUNT_LOADING = "enable_user_account_loading";
export const ENABLE_USER_ACCOUNT = "enable_user_account";
export const DISABLE_USER_ACCOUNT_LOADING = "disable_user_account_loading";
export const DISABLE_USER_ACCOUNT = "disable_user_account";
export const SET_PASSWORD_User_LOADING = "set_password_user_loading";
export const SET_PASSWORD_User = "set_password_user";
export const DETACH_RESOURCE_OU = "detach_resource_ou";
export const NOT_ATTACH_RESOURCE_OU = "not_attach_resource_ou";
export const ATTACH_RESOURCE_OU = "attach_resource_ou";
export const ALL_TEMPLATE = "all_template";
export const ACCOUNT_CREATE_SUB_DP = "account_create_sub_dp";
export const SET_SUB_DP_CREATE_LOADING = 'set_sub_dp_create_loading';
export const GET_SEARCH_DP_LIST = 'get_search_dp_list';
export const SET_DELETE_ORG_LOADING = 'set_delete_org_loading';
export const GET_DELETE_ORG = 'get_delete_org';
export const SET_MODIFY_ORG_LOADING = 'set_modify_org_loading';
export const GET_MODIFY_ORG = 'get_modify_org';
export const SET_DP_INFO_LOADING = 'set_dp_info_loading';
export const GET_DP_INFO = 'get_dp_info';
export const FETCH_SERVICE_LINES = 'fetch_service_lines';
export const FETCH_SERVICE_LINES_FOR_SUBSCRIPTION = 'fetch_service_lines_for_subscription';
 
// Service Management
export const GET_USER_POLICY = "get_user_policy";
export const SET_VESSEL_PLANS_LOADING = "set_vessel_plans_loading"
export const GET_VESSEL_PLANS = "get_vessel_plans";
export const OU_DERIVED = 'ou_derived';
export const SET_VESSEL_LISTING_LOADING = "set_vessel_listing_loading"
export const SET_PRIVATE_VESSEL_LIST = "set_private_vessel_list";
export const SET_PRIVATE_VESSEL_LIST_LOADING = "set_private_vessel_list_loading";

// Alert Page
export const SET_SEARCH_ALERTS_LOADING = "set_search_alerts_loading";
export const SEARCH_ALERTS = "search_alerts";
export const SET_VESSEL_ALERTS_LOADING = "vessel_alerts_loading";
export const GET_VESSEL_ALERTS = "vessel_alerts";
export const MARK_AS_FIXED_ALERT = "mark_as_fixed_alert";
export const ALERTS_NAME = "alerts_name";
export const ALERTS_HISTORY = "alerts_history";
export const DELETE_ALERT = "delete_alert"
export const DELETE_ALERT_LOADING = "delete_alert_loading"

// Dp Alert Page
export const GET_DP_ALERTS = "get_dp_alerts";
export const GET_DP_ALERTS_LOADING = "get_dp_alerts_loading"
export const UPDATE_DP_ALERT = "update_dp_alert";
export const UPDATE_DP_ALERT_LOADING = "update_dp_alert_loading"
export const UPDATE_DP_ALERT_NOTIFICATION = "update_dp_alert_notification"
export const UPDATE_DP_ALERT_NOTIFICATION_LOADING = "update_dp_alert_notification_loading"
export const DELETE_DP_ALERT_LINK_AVAILABILITY = "delete_dp_alert_link_availability"
export const DELETE_DP_ALERT_LINK_AVAILABILITY_LOADING = "delete_dp_alert_link_availability_loading"
export const GET_DP_ALERT_AUDIT_LOGS = "get_dp_alert_audit_logs"
export const GET_DP_ALERT_AUDIT_LOGS_LOADING = "get_dp_alert_audit_logs_loading"
export const UPDATE_DP_ALERT_STATUS_LOADING = "update_dp_alert_status"
export const UPDATE_DP_ALERT_STATUS = "update_dp_alert_status_loading"

// Site Alert Page
export const GET_SITE_ALERTS = "get_site_alerts";
export const GET_SITE_ALERTS_LOADING = "get_site_alerts_loading"
export const UPDATE_SITE_ALERT = "update_site_alert";
export const UPDATE_SITE_ALERT_LOADING = "update_site_alert_loading"
export const UPDATE_SITE_ALERT_NOTIFICATION = "update_site_alert_notification"
export const UPDATE_SITE_ALERT_NOTIFICATION_LOADING = "update_site_alert_notification_loading"
export const DELETE_SITE_ALERT_LINK_AVAILABILITY = "delete_site_alert_link_availability"
export const DELETE_SITE_ALERT_LINK_AVAILABILITY_LOADING = "delete_site_alert_link_availability_loading"
export const GET_SITE_ALERT_AUDIT_LOGS = "get_site_alert_audit_logs"
export const GET_SITE_ALERT_AUDIT_LOGS_LOADING = "get_site_alert_audit_logs_loading"
export const UPDATE_SITE_ALERT_STATUS = "update_site_alert_status"
export const UPDATE_SITE_ALERT_STATUS_LOADING = "update_site_alert_status_loading"

// Edge Administration
export const GET_VESSEL_EDGE_INFO = "get_vessel_edge_info";

// Ticketing 
export const SET_TICKETS_LOADING = "set_tickets_loading";
export const GET_TICKETS = "get_tickets";
export const GET_SIM_BOX = "get_sim_box";
export const GET_SIM_BOXES = "get_sim_boxes";
export const GET_SIM_BOXES_LOADING = "get_sim_boxes_loading";
export const GET_SIM_BOXES_COUNT = "get_sim_boxes_count";
export const GET_LTE_PROVIDERS = "get_lte_providers";
export const GET_DATA_USAGE = "get_data_usage";
export const GET_DATA_USAGE_COUNT = "get_data_usage_count";
export const GET_DAILY_DATA_USAGE = "get_daily_data_usage";
export const GET_GRAPHICAL_DATA_USAGE = "get_graphical_data_usage";
export const SET_CELLULAR_DATA_USAGE_LOADING = 'set_cellular_data_usage_loading';
export const GET_CELLULAR_DATA_USAGE = 'get_cellular_data_usage'
export const GRAPHICAL_DATA_USAGE_LOADING = "graphical_data_usage_loading";
export const EXPORT_DATA_USAGE_REPORT = "export_data_usage_report";
export const GET_USAGE_VESSEL_LIST = "get_usage_vessel_list";
export const GET_TICKET_DETAILS = "get_ticket_details";
export const SET_TICKET_DETAILS_LOADING = "set_ticket_details_loading";
export const SEND_TICKET_EMAIL = "send_ticket_email";
export const GET_HOT_VESSELS = "get_hot_vessels"
export const GET_TICKET_COMMENTS = "get_ticket_comments";
export const SET_TICKET_COMMENTS_LOADING = "set_ticket_comments_loading";
export const GET_TICKET_DETAILS_FIELD = "get_ticket_details_fields";
export const SET_TICKET_DETAILS_FIELD_LOADING = "set_ticket_details_fields_loading";
export const GET_TICKET_ATTACHMENTS = "get_ticket_attachments";
export const SET_TICKET_ATTACHMENTS_LOADING = "set_ticket_attachments_loading";
export const GET_SINGLE_TICKET_ATTACHMENTS = "get_single_ticket_attachments";
export const UPDATE_TICKET = "update_ticket";
export const CREATE_NEW_TICKET = "create_new_ticket";
export const ADD_ATTACHMENTS_TO_TICKET = "add_attachments_to_ticket"
export const SEND_TICKET_COMMENT = "send_ticket_comment";
export const GET_TICKET_HISTORY = "get_ticket_history";
export const SET_TICKET_HISTORY_LOADING = "set_ticket_history_loading";
export const GET_TICKET_AGENTS_BY_NAME = "get_ticket_agents_by_name";
export const GET_TICKET_ALL_AGENTS = "get_ticket_all_agents";
export const GET_DP_DATA = "get_dp_data";

// FIREWALL REPORTS
export const GET_FIREALL_WIDGETS = "get_firewall_widgets";
export const GET_FIREWALL_ACTIONS_TODAY_GRAPH = "get_firewall_actions_today_graph";
export const GET_FIREWALL_RULE_NAME_GRAPH = "get_firewall_rule_name_graph";
export const GET_FIREWALL_TABLE_DATA = "get_firewall_table_data";
export const GET_FIREWALL_RULE_NAME_FILTER = "get_firewall_rule_name_filter";
export const GET_FIREWALL_TABLE_DATA_COUNT = "get_firewall_table_data_count";
export const GET_FIREWALL_LINE_CHART = "get_firewall_line_chart";

export const SET_LOADING_FIREWALL_WIDGETS = "set_loading_firewall_widgets";
export const SET_LOADING_FIREWALL_RISTRICT_PIECHART = "set_loading_firewall_ristrict_piechart";
export const SET_LOADING_FIREWALL_PIE_RULENAME = "set_loading_firewall_pie_rulename";
export const SET_LOADING_FIREWALL_RULE_FILTER = "set_loading_firewall_rule_filter";
export const SET_LOADING_FIREWALL_TABLE_DATA = "set_loading_firewall_table_data";
export const SET_LOADING_FIREWALL_COUNTS = "set_loading_firewall_counts";
export const SET_LOADING_FIREWALL_LINECHART = "set_loading_firewall_linechart";

// DASHBOARD
export const SET_VESSEL_DASHBOARD_LOADING = 'set_vessel_dashboard_loading';
export const GET_VESSEL_SUMMARY_DASHBOARD = "get_vessel_Summary_dashboard";
export const GET_WIDGEY_SUMMARY_DASHBOARD = "get_widget_summary_dashboard";
export const GET_TOP_WIDGET_WANLINK_STATUS_NEW_SUMM = "get_top_widget_wanlink_status_new_summ";
export const GET_WIDGET_LINK_STATUS_SUMMARY_DASHBOARD = "get_widget_link_status_summary_dashboard";
export const GET_VESSEL_SUMMARY_TABLE_COUNT="get_vessel_summary_table_count"
export const CLEAR_SITE_DASHBOARD = "clear_site_dashboard";
export const GET_NEW_SUMMARY_USAGE_TABLE= "get_new_summary_usage_table";
export const GET_NEW_SUMMARY_USAGE_TABLE_LOADING= "get_new_summary_usage_table_loading";
export const GET_NEW_SUMMARY_UPTIME_ALL_LINK_AVAILABLITY = "get_new_summary_uptime_all_link_availablity";
export const GET_NEW_SUMMARY_UPTIME_ALL_LINK_AVAILABLITY_LOADING = "get_new_summary_uptime_all_link_availablity_loading";
export const SET_VESSEL_TABLE_COUNT_LOADING = "get_vessel_table_count_loading";
export const SET_VESSEL_WAN_LINK_STATUS_LOADING = "set_vessel_wan_link_status_loading"
export const SPORTS_SITE_SUMMARY_COUNT_LOADING = "sports_site_summary_count_loading"

export const SET_VESSEL_SUMMARY_LOADING = 'set_vessel_summary_loading';
export const GET_VESSEL_SUMMARY_TABLE = "get_vessel_summary_table";

export const GET_VESSEL_LOC_WITH_ALERTS_LOADING = 'get_vessel_loc_with_alerts_loading';
export const GET_VESSEL_LOC_WITH_ALERTS = "get_vessel_loc_with_alerts";

export const GET_SYSTEM_INVENTORY = "get_system_inventory";
export const GET_EDGE_SERVER_STATUS = "get_edge_server_status";
export const GET_EDGE_SERVER_STATUS_LOADING = "edge_server_status_loading";

// DASHBOARD SINGLESTORE
export const SET_LINK_STATUS_PER_DEVICE_LOADING = "get_link_status_per_device_loading";
export const GET_LINK_STATUS_PER_DEVICE = "get_link_status_per_device";
export const GET_TOP_WIDGET_AVAILABILITY = "get_top_widget_availability"
export const GET_TOP_WIDGET_DATA_NEW_SUMM = "get_top_widget_data_new_summ"


//
export const GET_USER_DETAILS = "get_user_details";
export const UPDATE_USER_PROFILE = "update_user_profile";
export const USER_PREFERENCES_LOADING = "user_preferences_loading";
export const UPDATE_USER_PREFERENCES = "update_user_preferences";
export const GET_USER_PREFERENCES = "get_user_preferences";
export const USER_TIMEZONE = "user_timezone";
export const RESET_STATE = "reset_state";
export const GET_VESSELS_LISTING = "get_vessels_listing"
export const GET_USER_LOGIN_HISTORY = "get_user_login_history"

// Edge-Topology
export const GET_VESSEL_EDGE_TOPOLOGY_PRODUCTS = "get_vessel_edge_topology_products";
export const GET_PRODUCT_EDGE_TOPOLOGY_DEVICES = "get_product_edge_topology_devices";
export const GET_VESSEL_SUMMARY_TOPOLOGY = "get_vessel_summary_topology";
export const UPDATE_NAME = "update_name";
export const VESSEL_ADDRESS_MMSI = "vessel_address_mmsi"
export const GET_VESSEL_INFO = "get_vessel_info";
export const GET_ORG_HIRARCHY = "get_org_hirarchy"
export const UPDATE_MMSI_AND_STREETADDRESS = "update_mmsi_and_streetaddress";
export const GET_PARENT_DEVICE_OF_A_SITE = "get_parent_device_of_a_site";
export const UPDATE_PARENT_DEVICE_OF_A_SITE = "update_parent_device_of_a_site";
export const REBOOT_DEVICE = "reboot_device";

// SOFTWARE LISTING
export const SOFTWARE_PRODUCT = "software_product";
export const SET_SOFTWARE_LISTING_LOADING = "set_software_listing";
export const SOFTWARE_LISTING = "software_listing";
export const GET_SOFTWARE_VERSIONS_DEVICE_COUNT = "get_software_versions_device_count";
export const GET_SOFTWARE_VERSION_DEVICE_DETAILS = "get_software_version_device_details";
export const GET_SOFT_VERSION_DEVICE_DETAILS = "get_soft_version_device_details";
export const GET_KONNECT_APP_DOWNLOAD_LINKS = "get_konnect_app_download_links";
export const GET_VX_BUILD_DETAILS = "get_vx_build_details";

export const GET_CONFIGURED_ALERTS_FOR_DEVICE = "get_configured_alerts_for_device";
export const UPDATE_CREATE_DEVICE_ALERT_CONFIGURATION = "update_create_device_alert_configuration";
export const UPDATE_DELETE_DEVICE_ALERT_CONFIGURATION = "update_delete_device_alert_configuration";
export const UPDATE_DEVICE_ALERT_CONFIGURATION_SETTINGS = "update_device_alert_configuration_settings";
export const GET_DP_DOCUMENTS_LIST = "get_dp_documents_list";

//Edge Events
export const SET_EDGE_EVENTS_LOADING = "set_edge_events_loading";
export const SET_EDGE_EVENTS_FILTER_LOADING = 'set_edge_events_filter_loading';
export const SET_EDGE_EVENTS_TABLE_LOADING = 'set_edge_events_table_loading';
export const SET_EDGE_EVENTS_TABLE_COUNT_LOADING = 'set_edge_events_table_count_loading';
export const GET_EDGE_EVENTS = "get_edge_events"
export const GET_EDGE_EVENTS_FILTER = "get_edge_events_filter"
export const GET_EDGE_EVENTS_FILTER_TEMP = "get_edge_events_filter_temp"
export const EDGE_EVENTS = "edge_events"
export const GET_EDGE_EVENTS_TABLE = "get_edge_events_table";
export const GET_EDGE_EVENTS_TABLE_COUNT = "get_edge_events_table_count";
export const DOWNLOAD_EDGE_EVENTS_TABLE = "download_edge_events_table";
export const CLEAR_EDGE_EVENTS = "clear_edge_events";

// Site Charts
export const GET_SITE_RSSI = "get_site_rssi";
export const GET_SITE_SINR = "get_site_sinr";
export const GET_SITE_DATA_RATE = "get_site_data_rate";
export const GET_SITE_LINK_STATUS = "get_site_link_status";
export const GET_SITE_LATENCY_JITTER = "get_site_latency_jitter";
export const GET_SITE_THROUGHPUT = "get_site_throughput";
export const GET_SITE_INTERFACES = 'get_site_interfaces';
export const CLEAR_SITE_CHARTS = 'clear_site_charts';
export const DELETE_SITE_CHART_SERIES = 'delete_site_chart_series';
export const CLEAR_SITE_CHART_EVENTS = 'clear_site_chart_events';
export const GET_SITE_VSAT_SNR = 'get_site_vsat_snr'
export const GET_SITE_VSAT_TXPOWER = 'get_site_vsat_txpower'
export const GET_SITE_VSAT_POWER = 'get_site_vsat_power'
export const GET_SITE_VSAT_SYMBOL_RATE = 'get_site_vsat_symbol_rate'
export const GET_SITE_CLIENTS = 'get_site_clients'
export const GET_SITE_USAGE = 'get_site_usage'
export const GET_SITE_SYSTEM_UPTIME = 'get_site_system_uptime'
export const SET_SITE_CHARTS_RSSI_LOADING = 'set_site_charts_rssi_loading';
export const SET_SITE_CHARTS_SINR_LOADING = 'set_site_charts_sinr_loading';
export const SET_SITE_CHARTS_LINK_STATUS_LOADING = 'set_site_charts_link_status_loading';
export const SET_SITE_CHARTS_LATENCY_JITTER_LOADING = 'set_site_charts_latency_jitter_loading';
export const SET_SITE_CHARTS_THROUGHPUT_LOADING = 'set_site_charts_throughput_loading';
export const SET_SITE_CHARTS_VSAT_SNR_LOADING = 'set_site_charts_vsat_snr_loading';
export const SET_SITE_CHARTS_VSAT_TXPOWER_LOADING = 'set_site_charts_vsat_txpower_loading';
export const SET_SITE_CHARTS_VSAT_POWER_LOADING = 'set_site_charts_vsat_power_loading';
export const SET_SITE_CHARTS_VSAT_SYMBOL_RATE_LOADING = 'set_site_charts_vsat_symbol_rate_loading';
export const SET_SITE_CHARTS_SITE_INTERFACES_LOADING = 'set_Site_Charts_Site_Interfaces_Loading';
export const SET_SITE_CHARTS_SITE_DATA_RATE_LOADING = 'set_site_charts_site_data_rate_loading';
export const SET_SITE_CLIENTS_LOADING = 'set_site_clients_loading';
export const SET_SITE_USAGE_LOADING = 'set_site_usage_loading';
export const SET_SITE_SYSTEM_UPTIME_LOADING = 'set_site_system_uptime_loading';
export const SET_SITE_LAN_STATUS_LOADING = 'set_site_lan_status_loading';
export const GET_SITE_LAN_STATUS = 'get_site_lan_status';
export const SET_HUB_CLIENT_SDWAN_FLOWS_LOADING = 'set_hub_client_sdwan_flows_loading';
export const GET_HUB_CLIENT_SDWAN_FLOWS = 'get_hub_client_sdwan_flows';
export const SET_HUB_CLIENT_SDWAN_SPEED_LOADING = 'set_hub_client_sdwan_speed_loading';
export const GET_HUB_CLIENT_SDWAN_SPEED = 'get_hub_client_sdwan_speed';
export const SET_HUB_CLIENT_SDWAN_LATENCY_LOADING = 'set_hub_client_sdwan_latency_loading';
export const GET_HUB_CLIENT_SDWAN_LATENCY = 'get_hub_client_sdwan_latency';
export const SET_HUB_CLIENT_SDWAN_STATUS_LOADING = 'set_hub_client_sdwan_status_loading';
export const GET_HUB_CLIENT_SDWAN_STATUS = 'get_hub_client_sdwan_status';
export const SET_SDWAN_SPEEDTEST_LOADING = 'set_sdwan_speedtest_loading';
export const GET_SDWAN_SPEEDTEST = 'get_sdwan_speedtest';
export const SET_SITE_LINK_PROBE_NATIVE_LOADING = 'set_site_link_probe_native_loading';
export const GET_SITE_LINK_PROBE_NATIVE = 'get_site_link_probe_native';
export const SET_SITE_LINK_PROBE_VTP_LOADING = 'set_site_link_probe_vtp_loading';
export const GET_SITE_LINK_PROBE_VTP = 'get_site_link_probe_vtp';
export const SET_SDWAN_QOE_LOADING = 'set_sdwan_qoe_loading';
export const GET_SDWAN_QOE = 'get_sdwan_qoe';
export const SET_SDWAN_QOE_HMAP_LOADING = 'set_sdwan_qoe_hmap_loading';
export const GET_SDWAN_QOE_HMAP = 'get_sdwan_qoe_hmap';

//Inventory
export const SET_INVENTORY_LISTING_LOADING = "set_inventory_listing";
export const SET_DEPLOYED_LISTING_LOADING = "set_deployed_listing";
export const SET_DEPLOYED_LISTING_COUNT_LOADING = "set_deployed_listing_count";
export const SET_T0_AND_OPEN_EDGE_LOADING = "set_t0_and_open_edge_loading";
export const GET_INVENTORY_DEPLOYED_DATA = "get_inventory_deployed_data";
export const GET_T0_AND_OPEN_EDGE_DATA = 'get_t0_and_open_edge_data';
export const GET_INVENTORY_WAREHOUSE_TABLE_DATA = "get_inventory_warehouse_table_data";
export const INVENTORY_WAREHOUSE_CHANGE_GROUP = "inventory_warehouse_change_group";
export const GET_INVENTORY_WAREHOUSE_VESSEL_LIST = "get_inventory_warehouse_vessel_list";
export const SET_ASSIGN_INVENTORY_TO_VESSEL = "set_assign_inventory_to_vessel";
export const ASSIGN_INVENTORY_TO_VESSEL = "assign_inventory_to_vessel";
export const GET_LICENSE_TYPES = "get_license_types"
export const SET_LICENSE_TYPES = "set_license_types"
export const GET_DPS_DEFAULT_ACTIVE_CONFIG = "get_dps_default_active_config"
export const CREATE_AND_ASSIGN_INVENTORY = "create_and_assign_inventory";
export const GET_DP_LIST = "get_dp_list";
export const GET_INVENTORY_DEPLOYED_DATA_COUNT = "get_inventory_deployed_data_count";
export const SET_INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE = "set_inventory_assign_device_to_warehouse"
export const INVENTORY_ASSIGN_DEVICE_TO_WAREHOUSE = "inventory_assign_device_to_warehouse"
export const INVENTORY_DELETE_SITE = "inventory_delete_site"
export const INVENTORY_TOP_WIDGETS_REGISTERED_COUNT="INVENTORY_TOP_WIDGETS_REGISTERED_COUNT"
export const INVENTORY_TOP_WIDGET_KAAS_COUNT="inventory_top_widget_kaas_count"
export const INVENTORY_TOP_WIDGETS_WAREHOUSE_COUNT= "inventory_top_widgets_warehouse_count"
export const INVENTORY_DOWNLOAD_CONFIG = 'inventory-download_config';
export const INVENTORY_CHANGE_GROUP = 'inventory_change_group';
export const DOWNLOAD_INVENTORY_DEPLOYED_DATA = "download_inventory_deployed_data";
export const GET_CONFIG_PRODUCTS = 'get_config_products';
export const GET_WAN_PROFILE_LIST = 'get_wan_profile_list';
export const GET_POP_IPS_LIST = "get_pop_ips_list";
export const APPLY_GOLDEN_CONFIG = 'apply_golden_config';
export const APPLY_TRAFFIC_POLICY = 'apply_traffic_policy';
export const APPLY_POLICY_ROUTE = 'apply_policy_route';
export const APPLY_FIREWALL_RULE = "apply_firewall_rule";
export const APPLY_WAN_PROFILE = "apply_wan_profile";
export const APPLY_HUB_IP_CONFIG = "apply_hub_ip_config";
export const BACKUP_CONFIG_NOW = "backup-config-now";
export const DEVICE_LATEST_EOS_VERSION = "device_latest_eos_version";
export const UPGRADE_DEVICE_TO_LATEST_EOS_VERSION = "upgrade_device_to_latest_eos_version";
export const UPGRADE_DEVICE_TO_LATEST_EOS_VERSION_LOADING = "upgrade_device_to_latest_eos_version_loading";
export const GET_DEVICE_LIST = "get_device_list";
export const GET_DP_DEVICES = "get_dp_devices";
export const CREATE_INVENTORY_GROUP="create_group";
export const GET_INVENTORY_GROUP_LIST = "get_inventory_group_list";
export const GET_TRAFFIC_POLICY_LIST = "get_traffic_policy_list";
export const GET_POLICY_ROUTE_LIST = "get_policy_route_list";
export const GET_TRAFFIC_POLICY_LIST_V3 = "get_traffic_policy_list_v3";
export const GET_TRAFFIC_POLICY_LIST_V4 = "get_traffic_policy_list_v4";
export const GET_TRAFFIC_POLICY_LIST_V5 = "get_traffic_policy_list_v5";
export const GET_TRAFFIC_POLICY_LISTING_LOADING = "get_traffic_policy_listing_loading";
export const GET_POLICY_ROUTE_LIST_LOADING = "get_policy_route_list_loading";
export const GET_WAN_PROFILE_LISTING_LOADING = "get_wan_profile_listing_loading";
export const GET_POP_IPS_LISTING_LOADING = "get_pop_ips_listing_loading";
export const APPLY_TRAFFIC_POLICY_LOADING = "apply_traffic_policy_loading";
export const APPLY_POLICY_ROUTE_LOADING = "apply_policy_route_loading";
export const GET_TRAFFIC_POLICY_LOG_LIST_LOADING = "get_traffic_policy_log_list_loading";
export const APPLY_FIREWALL_RULE_LOADING = "apply_firewall_rule_loading";
export const APPLY_WAN_PROFILE_LOADING = "apply_wan_profile_loading";
export const APPLY_HUB_IP_CONFIG_LOADING = "apply_hub_ip_config_loading";
export const COPY_QUOTA_CONFIG_LOADING = "copy_quota_config_loading";
export const GET_TRAFFIC_POLICY_LOG_LIST = "get_traffic_policy_log_list";
export const GET_INVENTORY_GROUP_LIST_COUNT = "get_inventory_group_list_count"; 
export const GET_SITE_INFO_LIST = "get_site_info_list";
export const GET_SITE_INFO_LIST_COUNT = "get_site_info_list_count";
export const UPDATE_INVENTORY_GROUP="update_group";
export const DELETE_INVENTORY_GROUP="delete_group";
export const INVENTORY_GROUP_DEVICES_EOS_UPGRADE="inventory_group_devices_eos_upgrade'";
export const SET_DEVICE_HISTORY_LOADING = 'set_device_history_loading';
export const GET_DEVICE_HISTORY = 'get_device_history';
export const SET_DEVICE_CONFIG_ACTION_LOGS_LOADING = 'set_device_config_logs_loading';
export const GET_DEVICE_CONFIG_ACTION_LOGS = 'get_device_config_logs';
export const SET_DEVICE_EOS_HISTORY_EVENTS_LOADING = 'set_device_eos_history_events_loading';
export const GET_DEVICE_EOS_HISTORY_EVENTS = 'get_device_history_events';
export const SET_DEVICE_LICENSE_HISTORY_LOADING = 'set_device_license_history_loading';
export const GET_DEVICE_LICENSE_HISTORY = 'get_device_license_history';
export const SET_UPGRADE_INVENTORY_LICENSE_LOADING = 'set_upgrade_inventory_license_loading';
export const GET_UPGRADE_INVENTORY_LICENSE = 'get_upgrade_inventory_license';
export const IS_INVENTORY_PREVIOUS_PAGE = 'is_inventory_previous_page';
export const SET_UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION_LOADING = 'set_upgrade_warehouse_device_to_latest_eos_version_loading'
export const UPGRADE_WAREHOUSE_DEVICE_TO_LATEST_EOS_VERSION = 'upgrade_warehouse_device_to_latest_eos_version'
export const GET_WIFI_INTERFACES = 'get_wifi_interfaces';
export const SET_WIFI_INTERFACES_LOADING = 'set_wifi_interfaces_loading';
export const GET_ALL_INTERFACES = 'get_all_interfaces';
export const SET_ALL_INTERFACES_LOADING = 'set_all_interfaces_loading';
export const GET_ALL_NETWORKS = 'get_all_networks';
export const SET_ALL_NETWORKS_LOADING = 'set_allnetworks_loading';
export const DELETE_INTERFACE = 'delete_interface';
export const DELETE_INTERFACE_LOADING = 'delete_interface_loading';
export const DELETE_LAN = 'delete_lan';
export const DELETE_LAN_LOADING = 'delete_lan_loading';
export const DELETE_WIFI = 'delete_wifi';
export const DELETE_WIFI_LOADING = 'delete_wifi_loading';
export const GET_PHYSICAL_INTERFACES = 'get_physical_interfaces';
export const GET_PHYSICAL_INTERFACES_LOADING = 'get_physical_interfaces_loading';
export const ADD_WAN_INTERFACE = 'add_wan_interface';
export const ADD_WAN_INTERFACE_LOADING = 'add_wan_interface_loading';
export const UPDATE_WAN_INTERFACE = 'update_wan_interface';
export const UPDATE_WAN_INTERFACE_LOADING = 'update_wan_interface_loading';
export const GET_WAN_PROFILES = "GET_WAN_PROFILES";
export const SET_WAN_PROFILES_LOADING = "SET_WAN_PROFILES_LOADING";
export const GET_WAN_PROFILE_DETAILS = "GET_WAN_PROFILE_DETAILS";
export const SET_WAN_PROFILE_DETAILS_LOADING = "SET_WAN_PROFILE_DETAILS_LOADING";
export const GET_UNUSED_WAN_INTERFACES = "GET_UNUSED_WAN_INTERFACES";
export const SET_UNUSED_WAN_INTERFACES_LOADING = "SET_UNUSED_WAN_INTERFACES_LOADING";
export const DELETE_WAN_PROFILE = "DELETE_WAN_PROFILE";
export const DELETE_WAN_PROFILE_LOADING = "DELETE_WAN_PROFILE_LOADING";
export const ENABLE_DISABLE_INTERFACE = 'enable_disable_interface';
export const ENABLE_DISABLE_INTERFACE_LOADING = 'enable_disable_interface_loading';
export const ENABLE_DISABLE_DHCP = 'enable_disable_dhcp';
export const ENABLE_DISABLE_DHCP_LOADING = 'enable_disable_dhcp_loading';
export const GET_FILTERED_NETWORKS = 'get_filtered_networks';
export const GET_FILTERED_NETWORKS_LOADING = 'get_filtered_networks_loading';
export const GET_FREE_LAN_ACCESS_INTERFACES = 'get_free_lan_access_interfaces';
export const GET_FREE_LAN_ACCESS_INTERFACES_LOADING = 'get_free_lan_access_interfaces_loading';
export const GET_ROUTER_DIDS = 'get_router_dids';
export const GET_ROUTER_DIDS_LOADING = 'get_router_dids_loading';
export const GET_REGISTER_DEVICE = 'get_register_device';
export const GET_REGISTER_DEVICE_LOADING = 'get_register_device_loading';
export const GET_DEREGISTER_DEVICE = 'get_deregister_device';
export const GET_DEREGISTER_DEVICE_LOADING = 'get_deregister_device_loading';
export const GET_DEVICE_DETAILS = 'get_device_deatils';
export const GET_DEVICE_DETAILS_LOADING = 'get_device_details_loading';
export const GET_SEARCH_DIDS = 'get_search_dids';
export const GET_SEARCH_DIDS_LOADING = 'get_search_dids_loading';
export const GET_SWAP_MODE = 'get_swap_mode';
export const GET_SWAP_MODE_LOADING = 'get_swap_mode_loading';
export const GET_DEVICE_TRANSFER = 'get_device_transfer';
export const GET_DEVICE_TRANSFER_LOADING = 'get_device_transfer_loading';
export const GET_DEVICE_LINK_STATUS = 'get_device_link_status';
export const GET_DEVICE_LINK_STATUS_LOADING = 'get_device_link_status_loading';
export const GET_LAN_TRUNK_FILTERED_NETWORKS_LOADING = 'get_lan_trunk_filtered_networks_loading';
export const GET_LAN_TRUNK_FILTERED_NETWORKS = 'get_lan_trunk_filtered_networks';
export const GET_SAVED_WAN_PROFILE_DATA = 'get_saved_wan_profile_data';
export const UPDATE_SYNC_CHECK_STATUS = 'update_sync_check_status';
export const SET_CANCEL_DE_REGISTER = 'set_cancel_de_register';
export const GET_CANCEL_DE_REGISTER = 'get_cancel_de_register';
export const GET_STATIC_ROUTES_LOADING = 'get_static_routes_loading';
export const GET_STATIC_ROUTES = 'get_static_routes';
export const DELETE_STATIC_ROUTE_LOADING = 'delete_static_route_loading';
export const DELETE_STATIC_ROUTE = 'delete_static_route';
export const GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS_LOADING = 'get_all_wan_interfaces_for_adv_settings_loading';
export const GET_ALL_WAN_INTERFACES_FOR_ADV_SETTINGS = 'get_all_wan_interfaces_for_adv_settings';
export const GET_ENABLE_DISABLE_NO_NAT_LOADING = 'get_enable_disable_no_nat_loading';
export const GET_ENABLE_DISABLE_NO_NAT = 'get_enable_disable_no_nat';
export const GET_LAN_IP_RANGES_LOADING = 'get_lan_ip_ranges_loading';
export const GET_LAN_IP_RANGES = 'get_lan_ip_ranges';
export const GET_ALL_PORT_CONFIGS_LOADING = 'get_all_port_configs_loading';
export const GET_ALL_PORT_CONFIGS = 'get_all_port_configs';
export const GET_ADD_EDIT_PORT_CONFIG_LOADING = 'get_add_edit_port_config_loading';
export const GET_ADD_EDIT_PORT_CONFIG = 'get_add_edit_port_config';
export const GET_DELETE_PORT_CONFIG_LOADING = 'get_delete_port_config_loading';
export const GET_DELETE_PORT_CONFIG = 'get_delete_port_config';
export const GET_DHCP_RESERVATIONS_LOADING = 'get_dhcp_reservations_loading';
export const GET_DHCP_RESERVATIONS = 'get_dhcp_reservations';
export const GET_DELETE_DHCP_RESERVATION_LOADING = 'get_delete_dhcp_reservation_loading';
export const GET_DELETE_DHCP_RESERVATION = 'get_delete_dhcp_reservation';
export const GET_ALL_FIREWALL_RULES_LOADING = 'get_all_firewall_rules_loading';
export const GET_ALL_FIREWALL_RULES = 'get_all_firewall_rules';
export const GET_INTERFACES_FIREWALL_RULES_LOADING = 'get_interfaces_firewall_rules_loading';
export const GET_INTERFACES_FIREWALL_RULES = 'get_interfaces_firewall_rules';
export const GET_ADD_EDIT_FIREWALL_RULE_LOADING = 'get_add_edit_firewall_rule_loading';
export const GET_ADD_EDIT_FIREWALL_RULE = 'get_add_edit_firewall_rule';
export const GET_ENABLE_DISABLE_FIREWALL_RULE_LOADING = 'get_enable_disable_firewall_rule_loading';
export const GET_ENABLE_DISABLE_FIREWALL_RULE = 'get_enable_disable_firewall_rule';
export const GET_ENABLE_DISABLE_PORT_FORWARD_LOADING = 'get_enable_disable_port_forward_loading';
export const GET_ENABLE_DISABLE_PORT_FORWARD = 'get_enable_disable_port_forward';
export const GET_DELETE_FIREWALL_RULE_LOADING = 'get_delete_firewall_rule_loading';
export const GET_DELETE_FIREWALL_RULE = 'get_delete_firewall_rule';
export const GET_ENABLE_DISABLE_DNS_CASHE_LOADING = 'get_enable_disable_dns_cashe_loading';
export const GET_ENABLE_DISABLE_DNS_CASHE = 'get_enable_disable_dns_cashe';
export const GET_LAN_MULTICAST_LOADING = 'get_lan_multicast_loading';
export const GET_LAN_MULTICAST = 'get_lan_multicast';
export const GET_SET_LAN_MULTICAST_LOADING = 'get_set_lan_multicast_loading';
export const GET_SET_LAN_MULTICAST = 'get_set_lan_multicast';
export const GET_DNS_PROXY_CONFIG_LOADING = 'get_dns_proxy_config_loading';
export const GET_DNS_PROXY_CONFIG = 'get_dns_proxy_config';
export const GET_DELETE_DNS_PROXY_CONFIG_LOADING = 'get_delete_dns_proxy_config_loading';
export const GET_DELETE_DNS_PROXY_CONFIG = 'get_delete_dns_proxy_config';
export const GET_IP_CONFIG_UPDATE_LOADING = 'get_ip_config_update_loading';
export const GET_IP_CONFIG_UPDATE = 'get_ip_config_update';
export const SET_FIREWALL_RULE_PRIORITY_LOADING = 'set_firewall_rule_priority_loading';
export const SET_PAUSE_LICENSE = 'set_pause_license';
export const GET_PAUSE_LICENSE = 'get_pause_license';
export const SET_RESUME_LICENSE = 'set_resume_license';
export const GET_RESUME_LICENSE = 'get_resume_license';
export const SET_WH_ProdGP_DEVICE_LIST = 'set_wh_prodgp_device_list';
export const GET_WH_ProdGP_DEVICE_LIST = 'get_wh_prodgp_device_list';
export const SET_TRANSFER_LICENSE_LOADING = 'set_transfer_license_loading';
export const GET_TRANSFER_LICENSE = 'get_transfer_license';
export const SET_CANCEL_PAUSE_LICENSE_LOADING = 'set_cancel_pause_license_loading';
export const GET_CANCEL_PAUSE_LICENSE = 'get_cancel_pause_license';
export const SET_INVENTORY_SYNC_DATA = 'set_inventory_sync_data';
export const GET_INVENTORY_SYNC_DATA = 'get_inventory_sync_data';
export const TRACK_INVENTORY_SYNC_DATA = 'track_inventory_sync_data';
export const SET_ATTACH_DEVICE_TO_SITE_LOADING = 'set_attack_device_to_site_loading';
export const GET_ATTACH_DEVICE_TO_SITE = 'get_attach_device_to_site';
export const SET_CREATE_SHARE_CONFIG_LOADING = 'set_create_share_config_loading';
export const CREATE_SHARE_CONFIG = 'create_share_config';
export const SET_SHARED_CONFIG_PER_CONFIG_LOADING = 'set_shared_config_per_config_loading';
export const GET_SHARED_CONFIG_PER_CONFIG = 'get_shared_config_per_config';
export const SET_UPDATE_SHARED_CONFIG_LOADING = 'set_update_shared_config_loading';
export const UPDATE_SHARED_CONFIG = 'update_shared_config';
export const SET_DELETE_SHARED_CONFIG_LOADING = 'set_delete_shared_config_loading';
export const DELETE_SHARED_CONFIG = 'delete_shared_config';

//Identity Rules
export const GET_IDENTITY_RULES = 'get_identity_rules';
export const GET_IDENTITY_RULES_LOADING = 'get_identity_rules_loading';
export const GET_IDENTITY_RULE_BY_ID = 'get_identity_rule_by_id';
export const GET_IDENTITY_RULES_BY_ID_LOADING = 'get_identity_rules_by_id_loading';
export const CREATE_UPDATE_IDENTITY_RULE = 'create_update_identity_rule';
export const CREATE_UPDATE_IDENTITY_RULE_LOADING = 'create_update_identity_rule_loading';
export const DELETE_IDENTITY_RULE = 'delete_identity_rule';
export const DELETE_IDENTITY_RULE_LOADING = 'delete_identity_rule_loading';

//High Availability
export const HIGH_AVAILABILITY = "high_availability";
export const GETTING_HA = "getting_ha";
export const GET_HIGH_AVAILABILITY_DEVICE = "get_high_availability_device";
export const CREATE_HA = "create_ha";
export const CREATING_HA = "creating_ha";
export const SYNC_DEVICE = "sync";
export const SYNCING_DEVICE = "syncing";
export const UPDATE_DEVICE = "update";
export const UPDATING_DEVICE = "updating_device";
export const DELETE_HIGH_AVAILABILITY = "delete_high_availability";
export const DELETING_HA = "deleting_ha";

//Activity Reports
export const SET_ACTIVITY_REPORTS_LOADING = "set_activity_reports_loading";
export const SET_ACTIVITY_REPORTS_APPS_LOADING = 'set_activity_reports_apps_loading';
export const SET_ACTIVITY_REPORTS_VLANS_LOADING = 'set_activity_reports_vlans_loading';
export const GET_ALL_USERNAMES = "get_all_usernames";
export const GET_USAGE_WIDGETS =   "get_usage_widgets";
export const GET_USAGE_TABLE_DATA = "get_usage_table_data";
export const GET_LINE_CHART_USAGE = "get_line_chart_usage";
export const GET_CATEGORY_PIE_CHART_USAGE = "get_category_pie_chart_usage";
export const GET_TOP_APPLICATION_LINE_CHART = "get_top_application_line_chart";
export const GET_TOP_SITES_TABLE_DATA = "get_top_sites_table_data";
export const GET_TOP_APP_TOP_BLOCKED_PIE_CHART = "get_top_app_top_blocked_pie_chart";
export const SET_ACTIVITY_REPORTS_WIDGET_LOADING = "set_activity_reports_widget_loading";
export const SET_ACTIVITY_REPORTS_CATEGORY_PIE_LOADING = "set_activity_reports_category_pie_loading";
export const SET_ACTIVITY_REPORTS_APPLICATION_PIE_LOADING = "set_activity_reports_application_pie_loading";
export const SET_ACTIVITY_REPORTS_USAGE_LINE_CHART_LOADING = "set_activity_reports_usage_line_chart_loading";
export const SET_ACTIVITY_REPORTS_TOP_APP_LINE_CHART_LOADING = "set_activity_reports_top_app_line_chart_usage";
export const SET_ACTIVITY_REPORTS_TOP_USERS_LOADING = "set_activity_reports_top_users_loading";
export const SET_ACTIVITY_REPORTS_TOP_SITES_LOADING = "set_activity_reports_top_sites_loading";
export const GET_TOP_DOWNLOAD_UPLOAD_BLOCKED_APPLICATION = "get_top_download_upload_blocked_application";
export const GET_TOP_DOWNLOAD_UPLOAD_BLOCKED_DOMAIN = "get_top_download_upload_blocked_domain";
export const GET_TOP_DOWNLOAD_UPLOAD_BLOCKED_IP = "get_top_download_upload_blocked_ip";
export const SET_ACTIVITY_REPORTS_BOTTOM_TABLE_LOADING = "set_activity_reports_bottom_table_loading";
export const SET_ACTIVITY_REPORTS_BOTTOM_TABLE_DOMAIN_LOADING = "set_activity_reports_bottom_table_domain_loading";
export const SET_ACTIVITY_REPORTS_BOTTOM_TABLE_IP_LOADING = "set_activity_reports_bottom_table_ip_loading";
export const GET_TOP_BLOCKED_APP_BOTTOM_TABLE = "get_top_blocked_app_bottom_table";
export const SET_REPORTS__TOP_BLOCKED_APP_BOTTOM_TABLE_LOADING = "set_reports_top_blocked_app_bottom_table";
export const GET_ACTIVITY_REPORTS_CONTENT_FILTERS_TABLE = 'get_activity_reports_content_filters_table';
export const GET_ALL_APPLICATIONS = 'get_all_applications';
export const GET_ALL_VLANS = 'get_all_vlans';
export const GET_DPI_REPORTS_USER_MAX_RISK_TYPES = 'get_dpi_reports_user_max_risk_types';
export const SET_DPI_REPORTS_TOP_WIDGET_ALLSITE_RISK = 'set_dpi_reports_top_widget_allsite_risk';
export const GET_DPI_REPORTS_TOP_WIDGET_ALLSITE_RISK = 'get_dpi_reports_top_widget_allsite_risk';
export const GET_DPI_REPORTS_TOP_WIDGET_SINGLESITE_RISK = 'get_dpi_reports_top_widget_singlesite_risk';
export const SET_DPI_REPORTS_PIE_CHART_ALLSITE_RISK = 'set_dpi_reports_pie_chart_allsite_risk';
export const GET_DPI_REPORTS_PIE_CHART_ALLSITE_RISK = 'get_dpi_reports_pie_chart_allsite_risk';
export const GET_DPI_REPORTS_PIE_CHART_SINGLESITE_RISK = 'get_dpi_reports_pie_chart_singlesite_risk';

//Operational Reports 
export const SET_OPERATIONAL_USAGE_DATA_DUMP_TABLE_COUNT_LOADING = "operational_usage_data_dump_table_count_loading";
export const GET_OPERATIONAL_USAGE_DATA_DUMP_TABLE_COUNT = "operational_usage_data_dump_table_count";
export const SET_OPERATIONAL_USAGE_DATA_DUMP_TABLE_LOADING = 'operatonal_usage_data_dump_table_loading';
export const GET_OPERATIONAL_USAGE_DATA_DUMP_TABLE = 'operatonal_usage_data_dump_table';
export const SET_OPERATIONAL_USAGE_DATA_DUMP_DOWNLOAD_TABLE_LOADING = "operational_usage_data_dump_download_table_loading";
export const GET_OPERATIONAL_USAGE_DATA_DUMP_DOWNLOAD_TABLE = "operational_usage_data_dump_download_table"

//Operational Usage Timeseries Table
export const SET_OPERATIONAL_USAGE_TIMESERIES_TABLE_LOADING = "operational_usage_timeseries_table_loading";
export const GET_OPERATIONAL_USAGE_TIMESERIES_TABLE ="operational_usage_timeseries_table";
export const SET_OPERATIONAL_USAGE_TIMESERIES_TABLE_COUNT_LOADING = "operational_usage_timeseries_table_count_loading";
export const GET_OPERATIONAL_USAGE_TIMESERIES_TABLE_COUNT ="operational_usage_timeseries_table_count";
export const SET_OPERATIONAL_USAGE_DATA_SINGLE_SITE_PER_WAN_WISE_LOADING = "operational_usage_data_single_site_per_wan_usage_loading";
export const GET_OPERATIONAL_USAGE_DATA_SINGLE_SITE_PER_WAN_WISE = "operational_usage_data_single_site_per_wan_usage";
export const SET_OPERATIONAL_USAGE_FILTER_DEVICE_LIST_LOADING = "operational_usage_filter_device_list_loading";
export const GET_OPERATIONAL_USAGE_FILTER_DEVICE_LIST = "operational_usage_filter_device_list";
export const SET_OPERATIONAL_USAGE_FILTER_SW_LIST_LOADING = "operational_usage_filter_sw_list_loading";
export const GET_OPERATIONAL_USAGE_FILTER_SW_LIST = "operational_usage_filter_sw_list";

// Generated Reports
export const CREATE_DOWNLOAD_SERVICE = 'create_download_service';
export const SET_GENERATED_REPORTS_TABLE_LOADING = 'set_generated_reports_table_loading';
export const SET_GENERATED_REPORTS_TABLE_COUNT_LOADING = 'set_generated_reports_table_count_loading';
export const GET_GENERATED_REPORTS_TABLE = 'get_generated_reports_table_loading';
export const GET_GENERATED_REPORTS_TABLE_COUNT = 'get_generated_reports_table_count_loading';
export const CREATE_DOWNLOAD_SERVICE_FIREWALL = 'create_download_service_firewall';
export const DELETE_REPORT_SERVICE = 'delete_report_service';
export const CREATE_DOWNLOAD_SERVICE_CONTENT_FILTER = "create_download_service_content_filter";

// IAM Login History
export const SET_IAM_LOGIN_HISTORY_TABLE = 'set_iam_login_history_table';
export const SET_IAM_LOGIN_HISTORY_TABLE_COUNT = 'set_iam_login_history_table_count';
export const SET_IAM_LOGIN_HISTORY_TOP_WIDGET = 'set_iam_login_history_top_widget';
export const SET_IAM_LOGIN_HISTORY_FILTER_USER = 'set_iam_login_history_filter_user';
export const SET_IAM_LOGIN_HISTORY_FILTER_APP = 'set_iam_login_history_filter_app';
export const SET_IAM_LOGIN_HISTORY_FILTER_DESC_LIST = 'set_iam_login_history_filter_desc_list';
export const SET_IAM_LOGIN_HISTORY_TIMESERIES_CHART = 'set_iam_login_history_timeseries_chart';
export const GET_IAM_LOGIN_HISTORY_TABLE = 'get_iam_login_history_table';
export const GET_IAM_LOGIN_HISTORY_TABLE_COUNT = 'get_iam_login_history_table_count';
export const GET_IAM_LOGIN_HISTORY_TOP_WIDGET = 'get_iam_login_history_top_widget';
export const GET_IAM_LOGIN_HISTORY_FILTER_USER = 'get_iam_login_history_filter_user';
export const GET_IAM_LOGIN_HISTORY_FILTER_APP = 'get_iam_login_history_filter_app';
export const GET_IAM_LOGIN_HISTORY_TIMESERIES_CHART = 'get_iam_login_history_timeseries_chart';
export const GET_IAM_LOGIN_HISTORY_FILTER_DESC_LIST = 'get_iam_login_history_filter_desc_list';

// Audit Logs
export const AUDIT_LOGS = "audit_logs";
//white label
export const DOMAIN_NAME="domain_name";
export const DOMAIN_CONFIG="domain_config"

// Config
export const GET_BACKUP_CONFIG_DATA = "get_backup_config_data";
export const SET_BACKUP_CONFIG_DATA_LOADING = "set_backup_config_data_loading";
export const COPY_CONFIG_TO_MANUAL_BACKUP = "copy_config_to_manual_backup";
export const DELETE_MANUAL_BACKUP_CONFIG= "delete_manual_backup_config"
export const GET_DEFAULT_CONFIG_LISTING = 'get_default_config_listing';
export const EDIT_DEFAULT_CONFIG = 'edit_default_config';
export const CREATE_DEFAULT_CONFIG = 'create_default_config';
export const DELETE_DEFAULT_CONFIG = 'delete_default_config';
export const GET_DEFAULT_PRODUCTS = 'get_default_products';
export const GET_CONFIG_SOFTWARE_VERSIONS = 'get_config_software_versions';
export const GET_CONFIG_STATUS = 'get_config_status';
export const GET_GROUP_TRANSCATION_CONFIG_STATUS = "get_group_transcation_config_status";
export const SET_CONFIG_STATUS_DOWNLOAD_LOADING = "set_config_status_download_loading";
export const SET_DEVICE_STATUS_DOWNLOAD_LOADING = "set_device_status_download_loading";

// Maintenance
export const GET_MAINTENANCE_INFO = "get_maintenance_info";

// Group Settings
export const GET_GROUP_SETTINGS_DATA = "GET_GROUP_SETTINGS_DATA";
export const UPDATE_GROUP_SETTINGS_DATA = "UPDATE_GROUP_SETTINGS_DATA";
export const CREATE_SMTP_EMAIL_DATA = "CREATE_SMTP_EMAIL_DATA";
export const GET_SMTP_EMAIL_DATA = "GET_SMTP_EMAIL_DATA";
export const GET_MICROSOFT_GRAPH_EMAIL_DATA = "GET_MICROSOFT_GRAPH_EMAIL_DATA";
export const CREATE_MICROSOFT_GRAPH_EMAIL_DATA = "CREATE_MICROSOFT_GRAPH_EMAIL_DATA";
export const GET_SENDGRID_TABLE_DATA = "GET_SENDGRID_TABLE_DATA";
export const SET_SENDGRID_DATA_LOADING = "SET_SENDGRID_DATA_LOADING";
export const CREATE_DNS_DATA = "CREATE_DNS_DATA";
export const VERIFY_DNS_DATA = "VERIFY_DNS_DATA";
export const SEND_TEST_EMAIL = "SEND_TEST_EMAIL";
export const SMTP_TEST_EMAIL = "SMTP_TEST_EMAIL";
export const MS_GRAPH_TEST_EMAIL = "MS_GRAPH_TEST_EMAIL";
export const SMTP_DATA_DELETE = "SMTP_DATA_DELETE";
export const MSGRAPH_DATA_DELETE = "MSGRAPH_DATA_DELETE";
export const SENDGRID_DATA_DELETE = "SENDGRID_DATA_DELETE";
export const ACTIVATE_SENDGRID = "ACTIVATE_SENDGRID";
export const ACTIVATE_SMTP = "ACTIVATE_SMTP";
export const ACTIVATE_MSGRAPH = "ACTIVATE_MSGRAPH";

// SSO
export const SAVE_SSO_CONFIG = "SAVE_SSO_CONFIG";
export const UPDATE_SSO_CONFIG = "UPDATE_SSO_CONFIG";
export const DELETE_SSO_CONFIG = "DELETE_SSO_CONFIG";
export const VERIFY_SSO_CONNECTION = "VERIFY_SSO_CONNECTION";
export const FETCH_SSO_ORGANIZATIONS = "FETCH_SSO_ORGANIZATIONS";
export const SET_SSO_ORGANIZATIONS_LOADING = "SET_SSO_ORGANIZATIONS_LOADING";
export const SET_DOMAIN_SSO_CHECK = "SET_DOMAIN_SSO_CHECK";
export const SET_SSO_CODE = "SET_SSO_CODE";

// Content Filter
export const SET_CF_TOP_USERS_TABLE_LOADING = 'set_cf_top_users_table_loading';
export const SET_CF_TOP_USERS_TABLE_COUNT_LOADING = 'set_cf_top_users_table_count_loading';
export const SET_CF_TOP_SITES_TABLE_LOADING = 'set_cf_top_sites_table_loading';
export const SET_CF_TOP_SITES_TABLE_COUNT_LOADING = 'set_cf_top_sites_table_count_loading';
export const SET_CF_CATEGORY_PIE_LOADING = 'set_cf_category_pie_loading';
export const SET_CF_APPLICATION_PIE_LOADING = 'set_cf_application_pie_loading';
export const SET_CF_SUBCAT_PIE_LOADING = 'set_cf_subcat_pie_loading';
export const SET_CF_LINECHART_LOADING = 'set_cf_linechart_loading';
export const SET_CF_TW_TOP_SITE_LOADING = 'set_cf_tw_top_site_loading';
export const SET_CF_TW_TOP_USER_LOADING = 'set_cf_tw_top_user_loading';
export const SET_CF_TW_TOP_CATEGORY_LOADING = 'set_cf_tw_top_category_loading';
export const SET_CF_TW_TOP_DOMAIN_LOADING = 'set_cf_tw_top_domain_loading';
export const SET_CF_CATEGORY_LIST_LOADING = 'set_cf_category_list_loading';
export const SET_CF_APP_LIST_LOADING = 'set_cf_app_list_loading';
export const SET_CF_USER_LIST_LOADING = 'set_cf_user_list_loading';
export const SET_CF_VLAN_LIST_LOADING = 'set_cf_vlan_list_loading';
export const SET_CF_DEVICE_LIST_LOADING = 'set_cf_device_list_loading';
export const SET_CF_SUb_CATEGORY_LIST_LOADING = 'set_cf_sub_category_list_loading';
export const GET_CF_TOP_USERS_TABLE = 'get_cf_top_users_table';
export const GET_CF_TOP_USERS_TABLE_COUNT = 'get_cf_top_users_table_count';
export const GET_CF_TOP_SITES_TABLE = 'get_cf_top_sites_table';
export const GET_CF_TOP_SITES_TABLE_COUNT = 'get_cf_top_sites_table_count';
export const GET_CF_CATEGORY_PIE = 'get_cf_category_pie';
export const GET_CF_APPLICATION_PIE = 'get_cf_application_pie';
export const GET_CF_SUBCAT_PIE = 'get_cf_subcat_pie';
export const GET_CF_LINECHART = 'get_cf_linechart';
export const GET_CF_TW_TOP_SITE = 'get_cf_tw_top_site';
export const GET_CF_TW_TOP_USER = 'get_cf_tw_top_user';
export const GET_CF_TW_TOP_CATEGORY = 'get_cf_tw_top_category';
export const GET_CF_TW_TOP_DOMAIN = 'get_cf_tw_top_domain';
export const GET_CF_CATEGORY_LIST = 'get_cf_category_list';
export const GET_CF_APP_LIST = 'get_cf_app_list';
export const GET_CF_USER_LIST = 'get_cf_user_list';
export const GET_CF_VLAN_LIST = 'get_cf_vlan_list';
export const GET_CF_DEVICE_LIST = 'get_cf_device_list';
export const GET_CF_SUB_CATEGORY_LIST = 'get_cf_sub_category_list';
export const UPDATE_NEW_SUMMARY_START_DATE = 'update_new_summary_start_Date';
export const UPDATE_NEW_SUMMARY_END_DATE = 'update_new_summary_end_Date';
export const UPDATE_NEW_SUMMARY_WAN_TYPE = 'update_new_summary_wan_Type';

// Summary Dashboard
export const SET_DASHBOARD_PIE_USAGEPER_WANTYPE_LOADING = 'set_dashboard_pie_usageper_wantype_loading';
export const SET_DASHBOARD_HISTORGRAM_USAGEPER_WANTYPE_LOADING = 'set_dashboard_histogram_usageper_wantype_loading';
export const SET_DASHBOARD_HISTORGRAM_USAGEPER_SITE_LOADING = 'set_dashboard_histogram_usageper_site_loading';
export const SET_DASHBOARD_USAGE_PIE_TOP10_APPS_LOADING = 'set_dashboard_usage_pie*_top10_apps_loading';
export const SET_DASHBOARD_PIE_WAN_USAGE_BYSITE_LOADING = 'set_dashboard_pie_wan_usage_bysite_loading';
export const SET_DASHBOARD_USAGE_HISOGRAM_UPLINK_DLK_LOADING = 'set_dashboard_usage_histogram_uplink_dlk_loading';
export const GET_DASHBOARD_PIE_USAGEPER_WANTYPE = 'get_dashboard_pie_usageper_wantype';
export const GET_DASHBOARD_HISTORGRAM_USAGEPER_WANTYPE = 'get_dashboard_histogram_usageper_wantype';
export const GET_DASHBOARD_HISTORGRAM_USAGEPER_SITE_COUNT = 'get_dashboard_histogram_usageper_site_count';
export const GET_DASHBOARD_USAGE_PIE_TOP10_APPS = 'get_dashboard_usage_pie*_top10_apps';
export const GET_DASHBOARD_PIE_WAN_USAGE_BYSITE = 'get_dashboard_pie_wan_usage_bysite';
export const GET_DASHBOARD_USAGE_HISOGRAM_UPLINK_DLK = 'get_dashboard_usage_histogram_uplink_dlk';
export const SET_DASHBOARD_USAGE_HISTOGRAM_BYSITE_LOADING = 'set_dashboard_usage_histogram_bysite_loading';
export const GET_DASHBOARD_USAGE_HISTOGRAM_BYSITE = 'get_dashboard_usage_histogram_bysite';

export const SET_DASHBOARD_UPTIME_SITESTATISTICS_TABLE_LOADING = 'set_dashboard_uptime_sitestatistics_table_loading';
export const SET_DASHBOARD_UPTIME_LINECHART_BYWAN_LOADING = 'set_dashboard_uptime_linechart_bywan_loading';
export const SET_DASHBOARD_UPTIME_PIECHART_BYSITE_LOADING = 'set_dashboard_uptime_piechart_bysite_loading';
export const SET_DASHBOARD_UPTIME_PIECHART_BYWAN_LOADING = 'set_dashboard_uptime_piechart_bywan_loading';
export const SET_DASHBOARD_UPTIME_LINECHART_BYSITE_LOADING = 'set_dashboard_uptime_linechart_bysite_loading';
export const GET_DASHBOARD_UPTIME_SITESTATISTICS_TABLE = 'get_dashboard_uptime_sitestatistics_table';
export const GET_DASHBOARD_UPTIME_LINECHART_BYWAN = 'get_dashboard_uptime_linechart_bywan';
export const GET_DASHBOARD_UPTIME_PIECHART_BYSITE = 'get_dashboard_uptime_piechart_bysite';
export const GET_DASHBOARD_UPTIME_PIECHART_BYWAN = 'get_dashboard_uptime_piechart_bywan';
export const GET_DASHBOARD_UPTIME_LINECHART_BYSITE = 'get_dashboard_uptime_linechart_bysite';

export const SET_DASHBOARD_ALERT_PIECHART_BYNAME_LOADING = 'set_dashboard_alert_piechart_byname_loading';
export const GET_DASHBOARD_ALERT_PIECHART_BYNAME = 'set_dashboard_alert_piechart_byname';
export const SET_DASHBOARD_ALERT_PIECHART_BYSITE_LOADING = 'set_dashboard_alert_piechart_bysite_loading';
export const GET_DASHBOARD_ALERT_PIECHART_BYSITE = 'set_dashboard_alert_piechart_bysite';
export const SET_DASHBOARD_ALERT_LINECHART_BYNAME_LOADING = 'set_dashboard_alert_linechart_byname_loading';
export const GET_DASHBOARD_ALERT_LINECHART_BYNAME = 'set_dashboard_alert_linechart_byname';
export const SET_DASHBOARD_ALERT_LINECHART_BYSITE_LOADING = 'set_dashboard_alert_linechart_bysite_loading';
export const GET_DASHBOARD_ALERT_LINECHART_BYSITE = 'set_dashboard_alert_linechart_bysite';
export const SET_DASHBOARD_ALERT_TOPWIDGET_LOADING = 'set_dashboard_alert_topwidget_loading';
export const GET_DASHBOARD_ALERT_TOPWIDGET = 'get_dashboard_alert_topwidget';
export const SET_DASHBOARD_PER_DEVICE_WAN_PROFILES = 'set_dashboard_per_device_wan_profiles';
export const GET_DASHBOARD_PER_DEVICE_WAN_PROFILES = 'get_dashboard_per_device_wan_profiles';
export const SET_DASHBOARD_ADVANCED_BONDING_LOADING = 'set_dashboard_advanced_bonding_loading';
export const GET_DASHBOARD_ADVANCED_BONDING = 'get_dashboard_advanced_bonding';
export const SET_DASHBOARD_LAN_STATUS_LOADING = 'set_dashboard_lan_status_loading';
export const GET_DASHBOARD_LAN_STATUS = 'get_dashboard_lan_status';
export const SET_DASHBOARD_CONNECTED_HUB_LOADING = 'set_dashboard_connected_hub_loading';
export const GET_DASHBOARD_CONNECTED_HUB = 'get_dashboard_connected_hub';
export const GET_TRENDS_LAN_USAGE_TOPWIDGET_USAGE = 'get_trends_lan_usage_topwidget_usage';
export const SET_TRENDS_LAN_USAGE_TOPWIDGET_USAGE_LOADING = 'set_trends_lan_usage_topwidget_usage_loading';
export const GET_TRENDS_LAN_USAGE_WIFI_TOPWIDGET_USAGE = 'get_trends_lan_usage_wifi_topwidget_usage';
export const SET_TRENDS_LAN_USAGE_WIFI_TOPWIDGET_USAGE_LOADING = 'set_trends_lan_usage_wifi_topwidget_usage_loading';
export const SET_TRENDS_LAN_NETWORK_TABLE_LOADING = "SET_TRENDS_LAN_NETWORK_TABLE_LOADING";
export const GET_TRENDS_LAN_NETWORK_TABLE = "GET_TRENDS_LAN_NETWORK_TABLE";
export const SET_TRENDS_LAN_CLIENT_TABLE_LOADING = "SET_TRENDS_LAN_CLIENT_TABLE_LOADING";
export const SET_TRENDS_LAN_WIFI_CLIENT_TABLE_LOADING = 'SET_TRENDS_LAN_WIFI_CLIENT_TABLE_LOADING';
export const SET_TRENDS_LAN_WIFI_CLIENT_AP_TABLE_LOADING = 'set_trends_lan_wifi_ap_client_table_loading';
export const SET_LAN_CLIENT_TABLE_COUNT = 'SET_LAN_CLIENT_TABLE_COUNT';
export const SET_LAN_NETWORK_TABLE_COUNT = 'SET_LAN_NETWORK_TABLE_COUNT';
export const SET_LAN_WIFI_CLIENT_TABLE_COUNT = 'SET_LAN_WIFI_CLIENT_TABLE_COUNT';
export const SET_OPEN_EDGE_SOFTWARE_UPDATE_LOADING = 'set_open_edge_siftware_update_loading';
export const GET_OPEN_EDGE_SOFTWARE_UPDATE = 'get_open_edge_siftware_update';
export const SET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS_LOADING = 'set_open_edge_siftware_update_status_loading';
export const GET_OPEN_EDGE_SOFTWARE_UPDATE_STATUS = 'get_open_edge_siftware_update_status';
export const GET_TRENDS_LAN_WIFI_AP_CLIENT_TABLE_COUNT = 'get_trends_lan_wifi_ap_client_table_count';

//Trends
export const SET_LAN_TABLE_DATA = 'SET_LAN_TABLE_DATA';
export type LanTopic = 'network' | 'client';

// Threat Dashboard 
export const GET_THREAT_DASHBOARD_TOPWIDGET = "get_threat_dashboard_topwidget";
export const SET_THREAT_DASHBOARD_TOPWIDGET_LOADING = "set_threat_dashboard_topwidget_loading";
export const GET_THREAT_DASHBOARD_TOPWIDGET_TOTAL = "get_threat_dashboard_topwidget_total";
export const SET_THREAT_DASHBOARD_TOPWIDGET_TOTAL_LOADING = "set_threat_dashboard_topwidget_total_loading";

export const GET_TOP_10_THREAT_BY_NAME = "get_top_10_threat_by_name";
export const SET_TOP_10_THREAT_BY_NAME_LOADING = "get_top_10_threat_by_name_loading";
export const GET_TOP_10_THREAT_BY_SEVERITY = "get_top_10_threat_by_severity"
export const SET_TOP_10_THREAT_BY_SERVERITY_LOADING= "get_top_10_threat_by_severity_loading";
export const GET_THREAT_DASHBORAD_BAR_CHART_ON_SEVERITY= "get_threat_dashboard_bar_chart_on_severity"
export const GET_THREAT_DASHBORAD_BAR_CHART_ON_SEVERITY_LOADING= "get_threat_dashboard_bar_chart_on_severity_loading"
export const SET_THREAT_DASHBOARD_TOP_10_THREAT_TABLE_LOADING= "set_threat_dashboard_top_10_threat_table_loading"
export const GET_TOP_10_THREAT_TABLE_DATA = "get_top_10_threat_table_data";
export const SET_THREAT_DASHBOARD_ALL_THREAT_TABLE_LOADING= "set_threat_dashboard_all_threat_table_loading"
export const GET_ALL_THREAT_TABLE_DATA = "get_alll_threat_table_data";
export const SET_THREAT_DASHBOARD_USER_THREAT_TABLE_LOADING= "set_threat_dashboard_user_threat_table_loading"
export const GET_USER_THREAT_TABLE_DATA = "get_user_threat_table_data";
export const UPDATE_NEW_SEVERITY_TYPE="update_new_serverity_type"
export const GET_THREAT_SITE_LIST = "get_threat_site_list";
export const GET_THREAT_SITE_LIST_LOADING = "get_threat_site_list_loading";
export const GET_THREAT_DEVICE_LIST = "get_threat_device_list";
export const GET_THREAT_DEVICE_LIST_LOADING = "get_threat_device_list_loading";
export const SET_THREAT_FILTERS = "set_threat_filters";
export const GET_THREAT_UNIQUE_DEVICE_LIST = 'get_threat_unique_device_list';
export const GET_THREAT_UNIQUE_IP_LIST = 'get_threat_unique_ip_list';
export const GET_THREAT_UNIQUE_CLASS_LIST = 'get_threat_unique_class_list';
export const GET_THREAT_UNIQUE_THREATNAME_LIST = 'get_threat_unique_threatname_list';
export const GET_THREAT_UNIQUE_DEVICE_LIST_LOADING = 'get_threat_unique_device_list_loading';
export const GET_THREAT_UNIQUE_IP_LIST_LOADING = 'get_threat_unique_ip_list_loading';
export const GET_THREAT_UNIQUE_CLASS_LIST_LOADING = 'get_threat_unique_class_list_loading';
export const GET_THREAT_UNIQUE_THREATNAME_LIST_LOADING = 'get_threat_unique_threatname_list_loading';
export const GET_THREAT_UNIQUE_ACTION_LIST = 'get_threat_unique_action_list';
export const GET_THREAT_UNIQUE_ACTION_LIST_LOADING = 'get_threat_unique_action_list_loading';
export const GET_THREAT_ACTION_PIE_DATA = 'get_threat_action_pie_data';
export const SET_THREAT_ACTION_PIE_DATA_LOADING = 'get_threat_action_pie_data_loading';
export const SET_THREAT_SEVERITY_CLASS_LIST_LOADING = 'get_threat_severity_class_list_loading';
export const GET_THREAT_SEVERITY_CLASS_LIST = 'get_threat_severity_class_list';
export const SET_THREAT_KONTROL_LOADING = 'create_threat_kontrol_loading';
export const CREATE_THREAT_KONTROL = 'create_threat_kontrol';
export const UPDATE_THREAT_KONTROL = 'update_threat_kontrol';
export const DELETE_THREAT_KONTROL = 'delete_threat_kontrol';
export const SET_THREATS_LOADING = 'set_threats_loading';
export const GET_THREATS = 'get_threats';
export const SET_THREATNAMES_LIST_LOADING = "set_threatnames_list_loading";
export const GET_THREATNAMES_LIST = "get_threatnames_list";
export const SET_SNORT_RULES_DETAILS = 'set_snort_rules_details';
export const GET_SNORT_RULES_DETAILS = 'get_snort_rules_details';

//Captive Dashboard
export const SET_CAPTIVE_SUBS_PIE_DATA_LOADING = 'get_captive_subs_pie_data_loading';
export const GET_CAPTIVE_SUBS_PIE_DATA = 'get_captive_subs_pie_data';
export const SET_CAPTIVE_USAGE_PIE_DATA_LOADING = 'get_captive_usage_pie_data_loading';
export const GET_CAPTIVE_USGAE_PIE_DATA = 'get_captive_usage_pie_data';


//csv
export const GET_CSV_DATA_TO_DOWNLOAD = 'get_csv_data_to_download';

export const GET_DRAWER_OPEN = 'get_drawer_open';

//System health
export const SET_SYSTEM_HEALTH_DEVICES_LOADING = 'set_system_health_devices_loading';
export const GET_SYSTEM_HEALTH_DEVICES = 'get_system_health_devices';
export const SET_SYSTEM_HEALTH_METRICS_LINE_CHART_CPU_LOADING = 'set_system_health_metrics_line_chart_cpu_loading';
export const GET_SYSTEM_HEALTH_METRICS_LINE_CHART_CPU = 'get_system_health_metrics_line_chart_cpu';
export const SET_SYSTEM_HEALTH_METRICS_LINE_CHART_MEMORY_LOADING = 'set_system_health_metrics_line_chart_memory_loading';
export const GET_SYSTEM_HEALTH_METRICS_LINE_CHART_MEMORY = 'get_system_health_metrics_line_chart_memory';
export const SET_SYSTEM_HEALTH_METRICS_LINE_CHART_CONTRACK_LOADING = 'set_system_health_metrics_line_chart_contrack_loading';
export const GET_SYSTEM_HEALTH_METRICS_LINE_CHART_CONTRACK = 'get_system_health_metrics_line_chart_contrack';
export const SET_SYSTEM_HEALTH_METRICS_LINE_CHART_LO_RX_DROPS_LOADING = 'set_system_health_metrics_line_chart_lo_rx_drops_loading';
export const GET_SYSTEM_HEALTH_METRICS_LINE_CHART_LO_RX_DROPS = 'get_system_health_metrics_line_chart_lo_rx_drops';
export const SET_SYSTEM_HEALTH_METRICS_LINE_CHART_SWAP_LOADING = 'set_system_health_metrics_line_chart_swap_loading';
export const GET_SYSTEM_HEALTH_METRICS_LINE_CHART_SWAP = 'get_system_health_metrics_line_chart_swap';
export const SET_SYSTEM_HEALTH_METRICS_LINE_CHART_TEMPERATURE_LOADING = 'set_system_health_metrics_line_chart_temperature_loading';
export const GET_SYSTEM_HEALTH_METRICS_LINE_CHART_TEMPERATURE = 'get_system_health_metrics_line_chart_temperature';
export const SET_SYSTEM_HEALTH_DISK_STORAGE_LINE_CHART_LOADING = 'set_system_health_disk_storage_line_chart_loading';
export const GET_SYSTEM_HEALTH_DISK_STORAGE_LINE_CHART = 'get_system_health_disk_storage_line_chart';
export const GET_SYSTEM_HEALTH_FLOW_COUNT_TABLE_LOADING = 'set_system_health_flow_count_line_chart'
export const SET_SYSTEM_HEALTH_FLOW_COUNT_TABLE_LOADING = 'set_system_health_flow_count_line_chart_loading';
export const SET_FLIGHT_SCHEDULE_DATA_LOADING = 'set_flight_schedule_data_loading';
export const GET_FLIGHT_SCHEDULE_DATA = 'get_flight_schedule_data';
export const SET_FLIGHT_TAILID_UPDATE_TABLE_LOADING = 'set_flight_tailId_update_table_loading';
export const GET_FLIGHT_TAILID_UPDATE_TABLE = 'get_flight_tailId_update_table';
export const SET_FLIGHT_TAILID_UPDATE_TABLE_COUNT_LOADING = 'set_flight_tailId_update_table_count_loading';
export const GET_FLIGHT_TAILID_UPDATE_TABLE_COUNT = 'get_flight_tailId_update_table_count';
export const SET_FLIGHT_SCHEDULE_TABLE_LOADING = 'set_flight_schedule_table_loading';
export const GET_FLIGHT_SCHEDULE_TABLE = 'get_flight_schedule_table';
export const SET_FLIGHT_SCHEDULE_TABLE_COUNT_LOADING = 'set_flight_schedule_table_count_loading';
export const GET_FLIGHT_SCHEDULE_TABLE_COUNT = 'get_flight_schedule_table_count';

// Hub
export const SET_HUB_DASHBOARD_HUB_DATA_LOADING = 'set_hub_dashboard_hub_data_loading';
export const GET_HUB_DASHBOARD_HUB_DATA = 'get_hub_dashboard_hub_data';
export const SET_HUB_DASHBOARD_HUB_DATA_COUNT_LOADING = 'set_hub_dashboard_hub_data_count_loading';
export const GET_HUB_DASHBOARD_HUB_DATA_COUNT = 'get_hub_dashboard_hub_data_count';
export const SET_HUB_DASHBOARD_CLIENT_TABLE_LOADING = 'set_hub_dashboard_client_table_loading';
export const GET_HUB_DASHBOARD_CLIENT_TABLE = 'get_hub_dashboard_client_table';
export const SET_HUB_DASHBOARD_SITES_DROPDOWN_LOADING = 'set_hub_dashboard_sites_dropdown_loading';
export const GET_HUB_DASHBOARD_SITES_DROPDOWN = 'get_hub_dashboard_sites_dropdown';
export const SET_HUB_DASHBOARD_CLIENT_WISE_LOADING = 'set_hub_dashboard_client_wise_loading';
export const GET_HUB_DASHBOARD_CLIENT_WISE = 'get_hub_dashboard_clint_wise';
export const SET_HUB_DASHBOARD_CLIENT_WISE_COUNT_LOADING = 'set_hub_dashboard_client_wise_count_loading';
export const GET_HUB_DASHBOARD_CLIENT_WISE_COUNT = 'get_hub_dashboard_client_wise_count';
export const SET_TOPOLOGY_HUB_TABLE = 'set_topology_hub_table';
export const GET_TOPOLOGY_HUB_TABLE = 'get_topology_hub_table';
export const SET_HUB_DASHBOARD_CARRIER_CLIENT_TABLE = 'set_hub_dashboard_carrier_client_table';
export const GET_HUB_DASHBOARD_CARRIER_CLIENT_TABLE = 'get_hub_dashboard_carrier_client_table';
export const SET_HUB_DASHBOARD_CARRIER_SERVICE_VRF_TABLE = 'set_hub_dashboard_carrier_service_vrf_table_loading';
export const GET_HUB_DASHBOARD_CARRIER_SERVICE_VRF_TABLE = 'get_hub_dashboard_carrier_service_vrf_table';
export const SET_CARRIER_HUB_SDWAN_STATUS = 'set_carrier_hub_sdwan_status_loading';
export const GET_CARRIER_HUB_SDWAN_STATUS = 'get_carrier_hub_sdwan_status';
export const SET_CARRIER_HUB_SDWAN_LATENCY = 'set_carrier_hub_sdwan_latency_loading';
export const GET_CARRIER_HUB_SDWAN_LATENCY = 'get_carrier_hub_sdwan_latency';
export const SET_CARRIER_HUB_SDWAN_DATA_RATES = 'set_carrier_hub_sdwan_data_rates_loading';
export const GET_CARRIER_HUB_SDWAN_DATA_RATES = 'get_carrier_hub_sdwan_data_rates';
export const SET_CARRIER_HUB_SDWAN_USAGE = 'set_carrier_hub_sdwan_usage_loading';
export const GET_CARRIER_HUB_SDWAN_USAGE = 'get_carrier_hub_sdwan_usage';
export const SET_CARRIER_HUB_SDWAN_HUBS = 'set_carrier_hub_sdwan_hubs';
export const GET_CARRIER_HUB_SDWAN_HUBS = 'get_carrier_hub_sdwan_hubs';
export const SET_CARRIER_HUB_AGENT_DROPDOWN = 'set_carrier_hub_agent_dropdown';
export const GET_CARRIER_HUB_AGENT_DROPDOWN = 'get_carrier_hub_agent_dropdown';
export const SET_CARRIER_HUB_WAN_DROPDOWN = 'set_carrier_hub_wan_dropdown';
export const GET_CARRIER_HUB_WAN_DROPDOWN = 'get_carrier_hub_wan_dropdown';
export const SET_CARRIER_HUB_SDWAN_HUB_DROPDOWN = 'set_carrier_gub_sdwan_hub_dropdown';
export const GET_CARRIER_HUB_SDWAN_HUB_DROPDOWN = 'get_carrier_gub_sdwan_hub_dropdown';
export const SET_CARRIER_HUB_SDWAN_BASE_RTT = 'set_carrier_hub_sdwan_base_rtt';
export const GET_CARRIER_HUB_SDWAN_BASE_RTT = 'get_carrier_hub_sdwan_base_rtt';
export const SET_CARRIER_HUB_SDWAN_CURRENT_RTT = 'set_carrier_hub_sdwan_current_rtt';
export const GET_CARRIER_HUB_SDWAN_CURRENT_RTT = 'get_carrier_hub_sdwan_current_rtt';
export const SET_CARRIER_HUB_SDWAN_PACKET_DROP = 'set_carrier_hub_sdwan_packet_drop';
export const GET_CARRIER_HUB_SDWAN_PACKET_DROP = 'get_carrier_hub_sdwan_packet_drop';
export const SET_CARRIER_HUB_SDWAN_TUNNEL_MIGRATION = 'set_carrier_hub_sdwan_tunnel_migration';
export const GET_CARRIER_HUB_SDWAN_TUNNEL_MIGRATION = 'get_carrier_hub_sdwan_tunnel_migration';
export const SET_CARRIER_HUB_SDWAN_PACING_RATE = 'set_carrier_hub_sdwan_pacing_rate';
export const GET_CARRIER_HUB_SDWAN_PACING_RATE = 'get_carrier_hub_sdwan_pacing_rate';
export const SET_CARRIER_HUB_SDWAN_BTLBW = 'set_carrier_hub_sdwan_btlbw';
export const GET_CARRIER_HUB_SDWAN_BTLBW = 'get_carrier_hub_sdwan_btlbw';
export const SET_CARRIER_HUB_SDWAN_BYTES_IN_FLIGHT = 'set_carrier_hub_sdwan_bytes_in_flight';
export const GET_CARRIER_HUB_SDWAN_BYTES_IN_FLIGHT = 'get_carrier_hub_sdwan_bytes_in_flight';
export const SET_CARRIER_HUB_SDWAN_CONGESTION_WINDOW = 'set_carrier_hub_sdwan_congestion_window';
export const GET_CARRIER_HUB_SDWAN_CONGESTION_WINDOW = 'get_carrier_hub_sdwan_congestion_window';
export const SET_CARRIER_HUB_SDWAN_DROPPED_DATAGRAMS = 'set_carrier_hub_sdwan_dropped_datagrams';
export const GET_CARRIER_HUB_SDWAN_DROPPED_DATAGRAMS = 'get_carrier_hub_sdwan_dropped_datagrams';
export const SET_CARRIER_HUB_SDWAN_ONE_WAY_DELAY_OWD = 'set_carrier_hub_sdwan_one_day_delay_owd';
export const GET_CARRIER_HUB_SDWAN_ONE_WAY_DELAY_OWD = 'get_carrier_hub_sdwan_one_day_delay_owd';
export const SET_CARRIER_HUB_SDWAN_ACK_COUNT = 'set_carrier_hub_sdwan_ack_count';
export const GET_CARRIER_HUB_SDWAN_ACK_COUNT = 'get_carrier_hub_sdwan_ack_count';
export const SET_CARRIER_HUB_SDWAN_PACING_LIMITED = 'set_carrier_hub_sdwan_pacing_limited';
export const GET_CARRIER_HUB_SDWAN_PACING_LIMITED = 'get_carrier_hub_sdwan_pacing_limited';
export const SET_CARRIER_HUB_SDWAN_SENT_DATAGRAMS = 'set_carrier_hub_sdwan_sent_datagrams';
export const GET_CARRIER_HUB_SDWAN_SENT_DATAGRAMS = 'get_carrier_hub_sdwan_sent_datagrams';
export const SET_CARRIER_HUB_SDWAN_BLOCK_COUNT = 'set_carrier_hub_sdwan_block_count';
export const GET_CARRIER_HUB_SDWAN_BLOCK_COUNT = 'get_carrier_hub_sdwan_block_count';
export const SET_CARRIER_HUB_SDWAN_AGENTS_LIST = 'set_carrier_hub_sdwan_agents_list';
export const GET_CARRIER_HUB_SDWAN_AGENTS_LIST = 'get_carrier_hub_sdwan_agents_list';
// wan
export const CREATE_AGENT_WAN_LOADING = "create_agent_wan_loading"
export const CREATE_AGENT_WAN = "create_agent_wan"
export const UPDATE_AGENT_WAN_LOADING = "update_agent_wan_loading"
export const UPDATE_AGENT_WAN = "update_agent_wan"
export const DELETE_AGENT_WAN_LOADING = "delete_agent_wan_loading"
export const DELETE_AGENT_WAN = "delete_agent_wan"
export const GET_AGENT_WANS_LOADING = "get_agent_wans_loading"
export const GET_AGENT_WANS = "get_agent_wans"
// wan profile
export const CREATE_AGENT_WAN_PROFILE_LOADING = "create_agent_wan_profile_loading"
export const CREATE_AGENT_WAN_PROFILE = "create_agent_wan_profile"
export const UPDATE_AGENT_WAN_PROFILE_LOADING = "update_agent_wan_profile_loading"
export const UPDATE_AGENT_WAN_PROFILE = "update_agent_wan_profile"
export const DELETE_AGENT_WAN_PROFILE_LOADING = "delete_agent_wan_profile_loading"
export const DELETE_AGENT_WAN_PROFILE = "delete_agent_wan_profile"
export const GET_AGENT_WAN_PROFILES_LOADING = "get_agent_wan_profiles_loading"
export const GET_AGENT_WAN_PROFILES = "get_agent_wan_profiles"
// hub
export const CREATE_AGENT_HUB_LOADING = "create_agent_hub_loading"
export const CREATE_AGENT_HUB = "create_agent_hub"
export const GET_AGENT_HUBS_LOADING = "get_agent_hubs_loading"
export const GET_AGENT_HUBS = "get_agent_hubs"
export const GET_AGENT_HUBS_PER_SERVICE_LOADING = "get_agent_hubs_per_service_loading"
export const GET_AGENT_HUBS_PER_SERVICE = "get_agent_hubs_per_service"
// service vlan
export const CREATE_AGENT_SERVICE_VLAN_LOADING = "create_agent_service_vlan_loading"
export const CREATE_AGENT_SERVICE_VLAN = "create_agent_service_vlan"
export const DELETE_AGENT_SERVICE_VLAN_LOADING = "delete_agent_service_vlan_loading"
export const DELETE_AGENT_SERVICE_VLAN = "delete_agent_service_vlan"
export const GET_AGENT_SERVICE_VLANS_LOADING = "get_agent_service_vlans_loading"
export const GET_AGENT_SERVICE_VLANS = "get_agent_service_vlans"
// profile
export const CREATE_AGENT_PROFILE_LOADING = "create_agent_profile_loading"
export const CREATE_AGENT_PROFILE = "create_agent_profile"
export const GET_AGENT_PROFILES_LOADING = "get_agent_profiles_loading"
export const GET_AGENT_PROFILES = "get_agent_profiles"
//route
export const CREATE_AGENT_ROUTE_LOADING = "create_agent_route_loading"
export const CREATE_AGENT_ROUTE = "create_agent_route"
export const DELETE_AGENT_ROUTE_LOADING = "delete_agent_route_loading"
export const DELETE_AGENT_ROUTE = "delete_agent_route"
export const GET_AGENT_ROUTES_LOADING = "get_agent_routes_loading"
export const GET_AGENT_ROUTES = "get_agent_routes"
//services
export const CREATE_AGENT_SERVICE_LOADING = "create_agent_service_loading"
export const CREATE_AGENT_SERVICE = "create_agent_service"
export const UPDATE_AGENT_SERVICE_LOADING = "update_agent_service_loading"
export const UPDATE_AGENT_SERVICE = "update_agent_service"
export const GET_AGENT_SERVICES_LOADING = "get_agent_services_loading"
export const GET_AGENT_SERVICES = "get_agent_services"
//agent config
export const CREATE_AGENT_CONFIG_LOADING = "create_agent_config_loading"
export const CREATE_AGENT_CONFIG = "create_agent_config"
export const GET_AGENT_CONFIGS_LOADING = "get_agent_configs_loading"
export const GET_AGENT_CONFIGS = "get_agent_configs"
//agent
export const CREATE_AGENT_LOADING = "create_agent_loading"
export const CREATE_AGENT = "create_agent"
export const GET_AGENTS_LOADING = "get_agents_loading"
export const GET_AGENTS = "get_agents"
export const GET_AGENT_CONFIG_SUMMARY_LOADING = "get_agent_config_summary_loading"
export const GET_AGENT_CONFIG_SUMMARY = "get_agent_config_summary"
export const GET_HUB4_AGENT_CONFIG_SUMMARY = 'get_hub4_agent_config_summary'
export const GET_HUB4_AGENT_CONFIG_SUMMARY_LOADING = "get_hub4_agent_config_summary_loading"
export const AGENT_CONFIG_ROW_DOWNLOAD_LOADING = "get_hub4_agent_config_row_download_loading"
export const AGENT_CONFIG_ROW_DOWNLOAD = "get_hub4_agent_config_row_download"
export const AGENT_CONFIG_SUMMARY = "agent_config_summary"
export const AGENT_CONFIG_SUMMARY_LOADING = "agent_config_summary_loading"
//access network
export const CREATE_AGENT_ACCESS_NETWORK_LOADING = "create_agent_access_network_loading"
export const CREATE_AGENT_ACCESS_NETWORK = "create_agent_access_network"
export const UPDATE_AGENT_ACCESS_NETWORK_LOADING = "update_agent_access_network_loading"
export const UPDATE_AGENT_ACCESS_NETWORK = "update_agent_access_network"
export const VERIFY_AGENT_CONFIG = "verify_agent_config"
export const VERIFY_AGENT_CONFIG_LOADING = "verify_agent_config_loading"
export const UPLOAD_AGENT_CONFIG_LOADING = "upload_agent_config_loading"
export const UPLOAD_AGENT_CONFIG = "upload_agent_config"
export const UPDATE_UPLOAD_AGENT_CONFIG_LOADING = "update_upload_agent_config_loading"
export const UPDATE_UPLOAD_AGENT_CONFIG = "update_upload_agent_config"
export const DELETE_AGENT_CONFIG = "delete_agent_config"
export const DELETE_AGENT_CONFIG_LAODING =  "delete_agent_config_loading"
export const COPY_AGENT_CONFIG = "copy_agent_config"
export const COPY_AGENT_CONFIG_LAODING =  "copy_agent_config_loading"
export const SAVE_AGENT_CONFIG = "save_agent_config"
export const SAVE_AGENT_CONFIG_LAODING =  "save_agent_config_loading"
//Agent hub event
export const GET_AGENT_HUB_EVENTS_LOADING = "get_agent_hub_events_loading"
export const GET_AGENT_HUB_EVENTS = "get_agent_hub_events"
export const GET_AGENT_HUB_EVENT_FILTERS_LOADING = "get_agent_hub_event_filters_loading"
export const GET_AGENT_HUB_EVENT_FILTERS = "get_agent_hub_event_filters"

//Hub Events 
export const GET_HUB_EVENTS_LOADING = "get_hub_events_loading";
export const GET_HUB_EVENTS = "get_hub_events";
export const GET_HUB_EVENT_FILTERS = "get_hub_events_filters"
export const GET_HUB_EVENT_FILTERS_LOADING = "get_hub_event_filters_loading"

//starlink
export const UPDATE_NEW_SUMMARY_SERVICE_LINE = 'update_new_summary_service_line';
export const UPDATE_NEW_SUMMARY_SERVICE_LINE_QUERY_PARAM = 'update_new_summary_service_line_query_param';
export const NEW_SUMMARY_SERVICE_ACCOUNTS = 'new_summary_service_account';
export const UPDATE_NEW_SUMMARY_SERVICE_ACCOUNTS = 'update_new_summary_service_account';
export const UPDATE_NEW_SUMMARY_SERVICE_LINE_SELECTED = 'update_new_summary_service_line_selected';
export const SET_HAS_USER_CHANGED_SERVICE_LINE = 'set_has_user_changed_service_line';

// Captive Dashboard
export const SET_CAPTIVE_DASHBOARD_SITES_SUBSCRIBERS_SESSIONS_TOP_WIDGET = 'set_captive_dashboard_sites_subscribers_sessions_top_widget';
export const GET_CAPTIVE_DASHBOARD_SITES_SUBSCRIBERS_SESSIONS_TOP_WIDGET = 'get_captive_dashboard_sites_subscribers_sessions_top_widget';
export const SET_CAPTIVE_DASHBOARD_PLANS_TOP_WIDGET = 'set_captive_dashboard_plans_top_widget';
export const GET_CAPTIVE_DASHBOARD_PLANS_TOP_WIDGET = 'get_captive_dashboard_plans_top_widget';
export const SET_CAPTIVE_DASHBOARD_USAGE_TOP_WIDGET = 'set_captive_dashboard_usage_top_widget';
export const GET_CAPTIVE_DASHBOARD_USAGE_TOP_WIDGET = 'get_captive_dashboard_usage_top_widget';
export const SET_CAPTIVE_DASHBOARD_TOP_SITES_USAGE_BAR = 'set_captive_dashboard_top_sites_usage_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_SITES_USAGE_BAR = 'get_captive_dashboard_top_sites_usage_bar';
export const SET_CAPTIVE_DASHBOARD_TOP_SITES_OVERAGE_USAGE_BAR = 'set_captive_dashboard_top_sites_overage_usage_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_SITES_OVERAGE_USAGE_BAR = 'get_captive_dashboard_top_sites_overage_usage_bar';
export const SET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LINE_CHART = 'set_captive_dashboard_subscribers_lineChart';
export const GET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LINE_CHART = 'get_captive_dashboard_subscribers_lineChart';
export const SET_CAPTIVE_DASHBOARD_SESSIONS_LINE_CHART = 'set_captive_dashboard_sessions_lineChart';
export const GET_CAPTIVE_DASHBOARD_SESSIONS_LINE_CHART = 'get_captive_dashboard_sessions_lineChart';
export const SET_CAPTIVE_DASHBOARD_USAGE_LINE_CHART = 'set_captive_dashboard_usage_lineChart';
export const GET_CAPTIVE_DASHBOARD_USAGE_LINE_CHART = 'get_captive_dashboard_usage_lineChart';
export const SET_CAPTIVE_DASHBOARD_OVERAGE_USAGE_LINE_CHART = 'set_captive_dashboard_overage_usage_lineChart';
export const GET_CAPTIVE_DASHBOARD_OVERAGE_USAGE_LINE_CHART = 'get_captive_dashboard_overage_usage_lineChart';
export const SET_CAPTIVE_DASHBOARD_SITES_TABLE = 'set_captive_dashboard_sites_table';
export const GET_CAPTIVE_DASHBOARD_SITES_TABLE = 'get_captive_dashboard_sites_table';
export const SET_CAPTIVE_DASHBOARD_TOP_SITES_SUBSCRIBERS_BAR = 'set_captive_dashboard_top_sites_subscribers_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_SITES_SUBSCRIBERS_BAR = 'get_captive_dashboard_top_sites_subscribers_bar';
export const SET_CAPTIVE_DASHBOARD_TOP_SITES_SESSIONS_BAR = 'set_captive_dashboard_top_sites_sessions_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_SITES_SESSIONS_BAR = 'get_captive_dashboard_top_sites_sessions_bar';
export const SET_CAPTIVE_DASHBOARD_SUBSCRIBERS_SESSIONS_TABLE = 'set_captive_dashboard_subscribers_sessions_table';
export const GET_CAPTIVE_DASHBOARD_SUBSCRIBERS_SESSIONS_TABLE = 'get_captive_dashboard_subscribers_sessions_table';
export const SET_CAPTIVE_DASHBOARD_TOP_PLANS_USERS_BAR = 'set_captive_dashboard_top_plans_users_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_PLANS_USERS_BAR = 'get_captive_dashboard_top_plans_users_bar';
export const SET_CAPTIVE_DASHBOARD_TOP_PLANS_USAGE_BAR = 'set_captive_dashboard_top_plans_usage_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_PLANS_USAGE_BAR = 'get_captive_dashboard_top_plans_usage_bar';
export const SET_CAPTIVE_DASHBOARD_TOP_PLANS_OVERAGE_USAGE_BAR = 'set_captive_dashboard_top_plans_overage_usage_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_PLANS_OVERAGE_USAGE_BAR = 'get_captive_dashboard_top_plans_overage_usage_bar';
export const SET_CAPTIVE_DASHBOARD_EVENTS_SUBSCRIBERS_PLAN_USAGE = 'set_captive_dashboard_events_subscribers_plan_usage_table';
export const GET_CAPTIVE_DASHBOARD_EVENTS_SUBSCRIBERS_PLAN_USAGE = 'get_captive_dashboard_events_subscribers_plan_usage_table';
export const SET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_USAGE_BAR = 'set_captive_dashboard_top_subscribers_usage_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_USAGE_BAR = 'get_captive_dashboard_top_subscribers_usage_bar';
export const SET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_OVERAGE_USAGE_BAR = 'set_captive_dashboard_top_subscribers_overage_usage_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_OVERAGE_USAGE_BAR = 'get_captive_dashboard_top_subscribers_overage_usage_bar';
export const SET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_SESSIONS_BAR = 'set_captive_dashboard_top_subscribers_sessions_bar';
export const GET_CAPTIVE_DASHBOARD_TOP_SUBSCRIBERS_SESSIONS_BAR = 'get_captive_dashboard_top_subscribers_sessions_bar';
export const SET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_HISTOGRAM = 'set_captive_dashboard_plans_subscribers_histogram';
export const GET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_HISTOGRAM = 'get_captive_dashboard_plans_subscribers_histogram';
export const SET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_OVERAGE_HISTOGRAM = 'set_captive_dashboard_plans_subscribers_overage_histogram';
export const GET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_OVERAGE_HISTOGRAM = 'get_captive_dashboard_plans_subscribers_overage_histogram';
export const SET_CAPTIVE_DASHBOARD_PLANS_USAGE_LINE_CHART = 'set_captive_dashboard_plans_usage_line_chart';
export const GET_CAPTIVE_DASHBOARD_PLANS_USAGE_LINE_CHART = 'get_captive_dashboard_plans_usage_line_chart';
export const SET_CAPTIVE_DASHBOARD_PLANS_OVERAGE_USAGE_LINE_CHART = 'set_captive_dashboard_plans_overage_usage_line_chart';
export const GET_CAPTIVE_DASHBOARD_PLANS_OVERAGE_USAGE_LINE_CHART = 'get_captive_dashboard_plans_overage_usage_line_chart';
export const SET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LIST = 'set_captive_dashboard_subscribers_list';
export const GET_CAPTIVE_DASHBOARD_SUBSCRIBERS_LIST = 'get_captive_dashboard_subscribers_list';
export const SET_CAPTIVE_DASHBOARD_PLANS_LIST = 'set_captive_dashboard_plans_list';
export const GET_CAPTIVE_DASHBOARD_PLANS_LIST = 'get_captive_dashboard_plans_list';
export const SET_CAPTIVE_DASHBOARD_SUBSCRIBER_SESSIONS_TABLE = 'set_captive_dashboard_subscriber_sessions_table';
export const GET_CAPTIVE_DASHBOARD_SUBSCRIBER_SESSIONS_TABLE = 'get_captive_dashboard_subscriber_sessions_table';
export const SET_CAPTIVE_DASHBOARD_EVENTS_TABLE = 'set_captive_dashboard_events_table';
export const GET_CAPTIVE_DASHBOARD_EVENTS_TABLE = 'get_captive_dashboard_events_table';
export const SET_CAPTIVE_DASHBOARD_EVENTS_IP_MAC_LIST = 'set_captive_dashboard_events_ip_mac_list';
export const GET_CAPTIVE_DASHBOARD_EVENTS_IP_MAC_LIST = 'get_captive_dashboard_events_ip_mac_list';
export const SET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_LINE_CHART = 'set_captive_dashboard_plans_subscribers_line_chart';
export const GET_CAPTIVE_DASHBOARD_PLANS_SUBSCRIBERS_LINE_CHART = 'get_captive_dashboard_plans_subscribers_line_chart';
export const SET_CAPTIVE_DASHBOARD_SITES_HISTOGRAM = 'set_captive_dashboard_sites_dropdown';
export const GET_CAPTIVE_DASHBOARD_SITES_HISTOGRAM = 'get_captive_dashboard_sites_dropdown';
export const SET_CAPTIVE_DASHBOARD_SITES_OVERAGE_HISTOGRAM = 'set_captive_dashboard_sites_overage_dropdown';
export const GET_CAPTIVE_DASHBOARD_SITES_OVERAGE_HISTOGRAM = 'get_captive_dashboard_sites_overage_dropdown';

export const SET_WAN_USAGE_REPORT_SINGLE_SITE_NETWORK_USAGE_LOADING = 'set_wan_usage_report_single_site_network_usage_loading';
export const GET_WAN_USAGE_REPORT_SINGLE_SITE_NETWORK_USAGE = 'get_wan_usage_report_single_site_network_usage';
export const SET_WAN_USAGE_REPORT_SINGLE_SITE_ALL_INTERFACE_USAGE_LOADING = 'set_wan_usage_report_single_site_all_interface_usage_loading';
export const GET_WAN_USAGE_REPORT_SINGLE_SITE_ALL_INTERFACE_USAGE = 'get_wan_usage_report_single_site_all_interface_usage';
export const SET_WAN_USAGE_REPORT_SINGLE_SITE_WAN_SELECTION_NETWORK_USAGE_LOADING = "set_wan_usage_report_single_site_wan_selection_network_usage_loading";
export const GET_WAN_USAGE_REPORT_SINGLE_SITE_WAN_SELECTION_NETWORK_USAGE = "get_wan_usage_report_single_site_wan_selection_network_usage";
export const SET_WAN_USAGE_REPORT_SINGLE_SITE_VSAT_SELECTION_NETWORK_USAGE_LOADING = "set_wan_usage_report_single_site_vsat_selection_network_usage_loading";
export const GET_WAN_USAGE_REPORT_SINGLE_SITE_VSAT_SELECTION_NETWORK_USAGE = "get_wan_usage_report_single_site_vsat_selection_network_usage";
export const SET_WAN_USAGE_REPORT_SINGLE_SITE_INTERFACE_USAGE_LOADING = 'set_wan_usage_report_single_site_interface_usage_loading';
export const GET_WAN_USAGE_REPORT_SINGLE_SITE_INTERFACE_USAGE = 'wan_usage_report_single_site_interface_usage';
// NETWORK TOPOLOGY 
export const SET_TOPOLOGY_TREE_TOP_WIDGET_LOADING = 'set_topology_tree_top_widget_loading'
export const GET_TOPOLOGY_TREE_TOP_WIDGET = 'get_topology_tree_top_widget'
export const GET_NETWORK_TOPOLOGY_SITE_DETAILS = 'get_network_topology_site_details';
export const GET_NETWORK_TOPOLOGY_SITE_DETAILS_LOADING = 'get_network_topology_site_details_loading';
export const GET_NETWORK_TOPOLOGY_DEVICE_INFO = 'get_network_topology_device_info';
export const SET_NETWORK_TOPOLOGY_DEVICE_INFO_LOADING = 'Set_network_topology_device_info_loading';
export const RESET_NETWORK_TOPOLOGY_DEVICE_INFO='reset_network_topology_device_info';
export const SET_HUB_INTERNET_DROPOFF_LIST_LOADING = 'set_hub_internet_dropoff_list_loading';
export const GET_HUB_INTERNET_DROPOFF_LIST = 'get_hub_internet_dropoff_list';
export const SET_HUB_RESELECT_LOADING = 'set_hub_reselect_loading';
export const GET_HUB_RESELECT = 'get_hub_reselect';

export const NETWORK_TOPOLOGY_DEVICE_DETAILS = 'network_topology_device_details'

//Reports Subscription
export const SET_REPORTS_SUBSCRIPTION_TABLE_LOADING =
  'set_reports_subscription_table_loading';
export const SET_REPORTS_SUBSCRIPTION_TABLE_COUNT_LOADING =
  'set_reports_subscription_table_count_loading';
export const GET_REPORTS_SUBSCRIPTION_TABLE =
  'get_reports_subscription_table_loading';
export const GET_REPORTS_SUBSCRIPTION_TABLE_COUNT =
  'get_reports_subscription_table_count_loading';

//SCHEDULED Reports
export const SET_SCHEDULED_REPORTS_TABLE_LOADING =
  'set_scheduled_reports_table_loading';
export const SET_SCHEDULED_REPORTS_TABLE_COUNT_LOADING =
  'set_scheduled_reports_table_count_loading';
export const GET_SCHEDULED_REPORTS_TABLE =
  'get_scheduled_reports_table_loading';
export const GET_SCHEDULED_REPORTS_TABLE_COUNT =
  'get_scheduled_reports_table_count_loading';

export const FETCH_SITE_LIST = 'fetch_site_list';
export const FETCH_SERVICE_LINE_LIST = 'fetch_service_line_list';
export const LIMITED_REPORT_ACCESS='limited_report_access'
export const SITE_ADMIN_ACCESS = 'site_admin_access';
export const SL_ADMIN_ACCESS = 'sl_admin_access';
export const CALL_SCHEDULED_REPORT='call_scheduled_report'

export const FETCH_FIREWALL_PROTOCOLS = "fetch_firewall_protocols";
export const FETCH_FIREWALL_PROTOCOLS_LOADING = "fetch_firewall_protocols_loading";

// Analytics
export const SET_ANALYTICS_TOP_CARDS_LOADING = 'set_analytics_top_cards_loading';
export const GET_ANALYTICS_TOP_CARDS = 'get_analytics_top_cards';
export const SET_ANALYTICS_BAR_CHART_LOADING = 'set_analytics_bar_chart_loading';
export const GET_ANALYTICS_BAR_CHART = 'get_analytics_bar_chart';
export const SET_ANALYTICS_LINE_CHART_LOADING = 'set_analytics_line_chart_loading';
export const GET_ANALYTICS_LINE_CHART = 'get_analytics_line_chart';
export const SET_ANALYTICS_TABLE_LOADING = 'set_analytics_line_loading';
export const GET_ANALYTICS_TABLE = 'get_analytics_table';

//AM Controller
export const UPDATE_AM_CONTROLLER_ACTION_STATUS = 'update_am_controller_action_status';
export const GET_IS_AM_AVAILABLE = 'get_is_am_available';
export const GET_MODEM_DETAILS = 'get_modem_details';
export const SET_FECTH_MODEM_DETAILS_LOADING = 'set_fetch_modem_details_loading';
export const GET_SIM_DETAILS = 'get_sim_details';
export const TRIGGER_TOWER_SCAN = 'trigger_tower_scan';
export const GET_TOWER_SCAN_RESULTS = 'get_tower_scan_results';
export const GET_SIM_PRIORITY_DETAILS = 'get_sim_priority_details';
export const UPDATE_SIM_PRIORITY_DETAILS = 'update_sim_priority_details';
export const RELOAD_SIM_DETAILS = 'reload_sim_details';
export const RESET_MODEM  = 'reset_modem';
export const UPDATE_SIM_SETTINGS = 'update_sim_settings';
export const GET_ALL_HUB_CLIENTS_LOADING = 'get_all_hub_clients_loading';
export const GET_ALL_HUB_CLIENTS = 'get_all_hub_clients';
export const SELECT_HUB_CLIENT_LOADING = 'select_hub_client_loading';
export const SELECT_HUB_CLIENT = 'select_hub_client';
export const GET_HUB_MTD_USAGE_LOADING = 'get_hub_mtd_usage_loading';
export const GET_HUB_MTD_USAGE = 'get_hub_mtd_usage';
export const GET_HUB_SERVER_STATUS_LOADING = 'get_hub_server_status_loading';
export const GET_HUB_SERVER_STATUS = 'get_hub_server_status';
export const GET_ACTIVE_HUB_CLIENT_LOADING = 'get_active_hub_client_loading';
export const GET_ACTIVE_HUB_CLIENT = 'get_active_hub_client';